import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap, finalize, map, share, take } from 'rxjs/operators';
import { CheckboxRequiredValidator, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { __extends, __spread, __read, __values } from 'tslib';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy, ViewEncapsulation, ElementRef, Directive, HostListener, Renderer2, ChangeDetectorRef, NgModule, HostBinding, Inject, Injectable, Optional, SecurityContext, SkipSelf, Attribute, ContentChild, TemplateRef, ViewChild, ContentChildren, forwardRef } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var TAB = 9;
/** @type {?} */
var ENTER = 13;
/** @type {?} */
var ESCAPE = 27;
/** @type {?} */
var SPACE = 32;
/** @type {?} */
var END = 35;
/** @type {?} */
var HOME = 36;
/** @type {?} */
var LEFT_ARROW = 37;
/** @type {?} */
var UP_ARROW = 38;
/** @type {?} */
var RIGHT_ARROW = 39;
/** @type {?} */
var DOWN_ARROW = 40;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @param {?} value
 * @return {?}
 */
function coerceBooleanProperty(value) {
    return value != null && "" + value !== 'false';
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Utility to dispatch any event on a Node.
 * @param {?} node
 * @param {?} event
 * @return {?}
 */
function dispatchEvent(node, event) {
    node.dispatchEvent(event);
    return event;
}
/**
 * @param {?} node
 * @param {?} type
 * @param {?=} canBubble
 * @return {?}
 */
function dispatchFakeEvent(node, type, canBubble) {
    return dispatchEvent(node, createFakeEvent(type, canBubble));
}
/**
 * @param {?} type
 * @param {?=} canBubble
 * @param {?=} cancelable
 * @return {?}
 */
function createFakeEvent(type, canBubble, cancelable) {
    if (canBubble === void 0) { canBubble = false; }
    if (cancelable === void 0) { cancelable = true; }
    /** @type {?} */
    var event = document.createEvent('Event');
    event.initEvent(type, canBubble, cancelable);
    return event;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** *
 * Returns the CSS classes assigned to an element as a sorted array.
  @type {?} */
var sortedClassNames = function (element) {
    return element.className.split(' ').sort();
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @template T
 * @param {?} base
 * @return {?}
 */
function mixinDisabled(base) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = _super.apply(this, __spread(args)) || this;
            _this._disabled = false;
            return _this;
        }
        Object.defineProperty(class_1.prototype, "disabled", {
            get: /**
             * @return {?}
             */
            function () {
                return this._disabled;
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._disabled = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        return class_1;
    }(base));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @template T
 * @param {?} base
 * @param {?=} defaultTabIndex
 * @return {?}
 */
function mixinTabIndex(base, defaultTabIndex) {
    if (defaultTabIndex === void 0) { defaultTabIndex = 0; }
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = _super.apply(this, __spread(args)) || this;
            _this._tabIndex = defaultTabIndex;
            return _this;
        }
        Object.defineProperty(class_1.prototype, "tabIndex", {
            get: /**
             * @return {?}
             */
            function () {
                return this.disabled ? -1 : this._tabIndex;
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._tabIndex = value != null ? value : defaultTabIndex;
            },
            enumerable: true,
            configurable: true
        });
        return class_1;
    }(base));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
var ButtonKinds = {
    Primary: 'primary',
    Secondary: 'secondary',
    SecondaryDark: 'secondaryDark',
    Danger: 'danger',
};
/** @enum {string} */
var ButtonTypes = {
    Button: 'button',
    Link: 'link',
};
var AptoHoldButtonDirective = /** @class */ (function () {
    function AptoHoldButtonDirective(element, renderer) {
        this.element = element;
        this.renderer = renderer;
        this.hold = new EventEmitter();
        this.timer = null;
        this.progressContainer = this.renderer.createElement('span');
        this.renderer.addClass(this.progressContainer, 'AptoHold');
        this.progressBar = this.renderer.createElement('span');
        this.renderer.addClass(this.progressBar, 'AptoHold-progressBar');
        this.renderer.appendChild(this.progressContainer, this.progressBar);
    }
    /**
     * @return {?}
     */
    AptoHoldButtonDirective.prototype._onMouseDown = /**
     * @return {?}
     */
    function () {
        this.startHold();
    };
    /**
     * @return {?}
     */
    AptoHoldButtonDirective.prototype._onMouseUp = /**
     * @return {?}
     */
    function () {
        this.cancelTimer();
    };
    /**
     * @return {?}
     */
    AptoHoldButtonDirective.prototype._onLeave = /**
     * @return {?}
     */
    function () {
        this.cancelTimer();
    };
    /**
     * @return {?}
     */
    AptoHoldButtonDirective.prototype.startHold = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.progressContainer) {
            this.progressContainer.classList.add('AptoHold--active');
            this.timer = setTimeout(function () {
                _this.hold.emit(_this.element);
                _this.cancelTimer();
            }, 2000);
        }
    };
    /**
     * @return {?}
     */
    AptoHoldButtonDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var el = this.element.nativeElement.querySelector('button');
        if (el && !el.hasAttribute('disabled')) {
            this.renderer.appendChild(el, this.progressContainer);
        }
        this.cancelTimer();
    };
    /**
     * @return {?}
     */
    AptoHoldButtonDirective.prototype.cancelTimer = /**
     * @return {?}
     */
    function () {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        if (this.progressContainer) {
            this.progressContainer.classList.remove('AptoHold--active');
        }
    };
    AptoHoldButtonDirective.decorators = [
        { type: Directive, args: [{
                    selector: 'apto-button[holdButton]'
                },] }
    ];
    /** @nocollapse */
    AptoHoldButtonDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    AptoHoldButtonDirective.propDecorators = {
        hold: [{ type: Output }],
        _onMouseDown: [{ type: HostListener, args: ['mousedown',] }],
        _onMouseUp: [{ type: HostListener, args: ['mouseup',] }],
        _onLeave: [{ type: HostListener, args: ['mouseleave',] }]
    };
    return AptoHoldButtonDirective;
}());
var AptoButtonComponent = /** @class */ (function () {
    function AptoButtonComponent(_changeDetectorRef) {
        this._changeDetectorRef = _changeDetectorRef;
        this._disabled = false;
        this.kind = ButtonKinds.Primary;
        this.title = null;
        this.type = ButtonTypes.Button;
        this.automation = null;
    }
    Object.defineProperty(AptoButtonComponent.prototype, "disabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this._disabled;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value !== this.disabled) {
                this._disabled = coerceBooleanProperty(value);
                this._changeDetectorRef.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    AptoButtonComponent.prototype._clickHandler = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    };
    /**
     * @return {?}
     */
    AptoButtonComponent.prototype.classes = /**
     * @return {?}
     */
    function () {
        return "AptoButton AptoButton--" + (this.type || ButtonTypes.Button) + " AptoButton--" + (this.kind || ButtonKinds.Primary);
    };
    AptoButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-button',
                    template: "<button\n    type=\"button\"\n    (click)=\"_clickHandler($event)\"\n    [ngClass]=\"classes()\"\n    [attr.disabled]=\"disabled ? 'disabled' : null\"\n    [attr.aria-disabled]=\"disabled ? 'true' : null\"\n    [attr.aria-label]=\"title ? title : null\"\n    [attr.data-automation]=\"automation ? automation : null\"\n><ng-content></ng-content></button>\n",
                    host: {
                        '[attr.disabled]': 'null',
                        '[attr.kind]': 'null',
                        '[attr.type]': 'null',
                        '[attr.title]': 'null'
                    },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".AptoButton{display:inline-block;margin:0;background:0 0;border:none;font-family:\"Open Sans\",sans-serif;font-weight:500;font-size:1.4rem;border-radius:3px;padding:.7rem 2rem;outline:0;white-space:nowrap;cursor:pointer;text-transform:uppercase;transition:color .15s ease-in-out,background-color .15s ease-in-out}.AptoButton:disabled{cursor:not-allowed}.AptoButton--link{padding:0}.AptoButton--primary{color:#fff;background-color:#64b5f6}.AptoButton--primary:hover{background-color:#1c92f2}.AptoButton--primary:disabled{background-color:#e0e0e0}.AptoButton--danger{color:#fff;background-color:#d32f2f}.AptoButton--danger:hover{background-color:#962020}.AptoButton--danger:disabled{background-color:#e06e6e}.AptoButton--link.AptoButton--primary{color:#64b5f6;background-color:transparent}.AptoButton--link.AptoButton--primary:hover{color:#1c92f2}.AptoButton--link.AptoButton--primary:disabled{color:#acd8fa}.AptoButton--link.AptoButton--secondary{color:#bdbdbd;background-color:transparent}.AptoButton--link.AptoButton--secondary:hover{color:#1c92f2}.AptoButton--link.AptoButton--secondary:disabled{color:#e3e3e3}.AptoButton--link.AptoButton--secondaryDark{color:grey;background-color:transparent}.AptoButton--link.AptoButton--secondaryDark:hover{color:#1c92f2}.AptoButton--link.AptoButton--secondaryDark:disabled{color:#a6a6a6}.AptoButton--link.AptoButton--danger{color:#d32f2f;background-color:transparent}.AptoButton--link.AptoButton--danger:hover{color:#962020}.AptoButton--link.AptoButton--danger:disabled{color:#e06e6e}.AptoHold{background-color:#bdbdbd;border-radius:3px;height:3px;display:block;visibility:hidden}.AptoHold .AptoHold-progressBar{background-color:#d32f2f;border-radius:3px;height:3px;width:0;display:block}.AptoHold.AptoHold--active{visibility:visible}.AptoHold.AptoHold--active .AptoHold-progressBar{width:100%;transition:width 2s linear}"]
                }] }
    ];
    /** @nocollapse */
    AptoButtonComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    AptoButtonComponent.propDecorators = {
        disabled: [{ type: Input }],
        kind: [{ type: Input }],
        title: [{ type: Input }],
        type: [{ type: Input }],
        automation: [{ type: Input }]
    };
    return AptoButtonComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoButtonComponentModule = /** @class */ (function () {
    function AptoButtonComponentModule() {
    }
    AptoButtonComponentModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        AptoButtonComponent,
                        AptoHoldButtonDirective
                    ],
                    exports: [
                        AptoButtonComponent,
                        AptoHoldButtonDirective
                    ]
                },] }
    ];
    return AptoButtonComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoCardComponent = /** @class */ (function () {
    function AptoCardComponent() {
    }
    AptoCardComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-card',
                    template: "<ng-content select=\"apto-card-header\"></ng-content>\n<ng-content select=\"apto-card-content\"></ng-content>\n<ng-content select=\"apto-card-footer\"></ng-content>\n",
                    host: { 'class': 'AptoCard' },
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".AptoCard{margin:10px 0;background:#fff;border:none;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);border-radius:2px;font-family:\"Open Sans\",sans-serif;font-weight:500;font-size:1.4rem;padding:0;display:block;position:relative}"]
                }] }
    ];
    return AptoCardComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoCardHeaderComponent = /** @class */ (function () {
    function AptoCardHeaderComponent() {
        this._noBottomPadding = false;
    }
    Object.defineProperty(AptoCardHeaderComponent.prototype, "noBottomPadding", {
        get: /**
         * @return {?}
         */
        function () {
            return this._noBottomPadding;
        },
        set: /**
         * @param {?} noBottomPadding
         * @return {?}
         */
        function (noBottomPadding) {
            this._noBottomPadding = coerceBooleanProperty(noBottomPadding);
        },
        enumerable: true,
        configurable: true
    });
    AptoCardHeaderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-card-header',
                    template: '<ng-content></ng-content>',
                    host: {
                        'class': 'AptoCardHeader',
                        '[class.AptoCardHeader--noBottomPadding]': 'noBottomPadding',
                    },
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".AptoCard{margin:10px 0;background:#fff;border:none;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);border-radius:2px;font-family:\"Open Sans\",sans-serif;font-weight:500;font-size:1.4rem;padding:0;display:block;position:relative}.AptoCardHeader{display:block;font-size:1.2rem;color:#9e9e9e;padding:1.6rem}.AptoCardHeader.AptoCardHeader--noBottomPadding{padding-bottom:0}"]
                }] }
    ];
    AptoCardHeaderComponent.propDecorators = {
        noBottomPadding: [{ type: Input }]
    };
    return AptoCardHeaderComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoCardContentComponent = /** @class */ (function () {
    function AptoCardContentComponent() {
        this._noPadding = false;
    }
    Object.defineProperty(AptoCardContentComponent.prototype, "noPadding", {
        get: /**
         * @return {?}
         */
        function () {
            return this._noPadding;
        },
        set: /**
         * @param {?} noPadding
         * @return {?}
         */
        function (noPadding) {
            this._noPadding = coerceBooleanProperty(noPadding);
        },
        enumerable: true,
        configurable: true
    });
    AptoCardContentComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-card-content',
                    template: '<ng-content></ng-content>',
                    host: {
                        'class': 'AptoCardContent',
                        '[class.AptoCardContent--noPadding]': 'noPadding',
                    },
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".AptoCard{margin:10px 0;background:#fff;border:none;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);border-radius:2px;font-family:\"Open Sans\",sans-serif;font-weight:500;font-size:1.4rem;padding:0;display:block;position:relative}.AptoCardContent{margin:0;padding:1.3rem 1.6rem;display:block}.AptoCardContent.AptoCardContent--noPadding{padding:0}"]
                }] }
    ];
    AptoCardContentComponent.propDecorators = {
        noPadding: [{ type: Input }]
    };
    return AptoCardContentComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoCardFooterLeftDirective = /** @class */ (function () {
    function AptoCardFooterLeftDirective() {
    }
    AptoCardFooterLeftDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[apto-card-footer-left],apto-card-footer-left',
                    host: { 'class': 'AptoCardFooter-left' }
                },] }
    ];
    return AptoCardFooterLeftDirective;
}());
var AptoCardFooterRightDirective = /** @class */ (function () {
    function AptoCardFooterRightDirective() {
    }
    AptoCardFooterRightDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[apto-card-footer-right],apto-card-footer-right',
                    host: { 'class': 'AptoCardFooter-right' }
                },] }
    ];
    return AptoCardFooterRightDirective;
}());
var AptoCardFooterComponent = /** @class */ (function () {
    function AptoCardFooterComponent() {
    }
    AptoCardFooterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-card-footer',
                    template: "<ng-content select=\"apto-card-footer-left\"></ng-content>\n<ng-content></ng-content>\n<ng-content select=\"apto-card-footer-right\"></ng-content>",
                    host: { 'class': 'AptoCardFooter' },
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".AptoCard{margin:10px 0;background:#fff;border:none;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);border-radius:2px;font-family:\"Open Sans\",sans-serif;font-weight:500;font-size:1.4rem;padding:0;display:block;position:relative}.AptoCardFooter{display:flex;padding:1.6rem;justify-content:space-between}.AptoCardFooter-left{margin-right:auto}.AptoCardFooter-right{margin-left:auto}"]
                }] }
    ];
    return AptoCardFooterComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoCardComponentModule = /** @class */ (function () {
    function AptoCardComponentModule() {
    }
    AptoCardComponentModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        AptoCardComponent,
                        AptoCardHeaderComponent,
                        AptoCardContentComponent,
                        AptoCardFooterComponent,
                        AptoCardFooterLeftDirective,
                        AptoCardFooterRightDirective
                    ],
                    exports: [
                        AptoCardComponent,
                        AptoCardHeaderComponent,
                        AptoCardContentComponent,
                        AptoCardFooterComponent,
                        AptoCardFooterLeftDirective,
                        AptoCardFooterRightDirective
                    ]
                },] }
    ];
    return AptoCardComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoGridColumnDirective = /** @class */ (function () {
    function AptoGridColumnDirective() {
    }
    Object.defineProperty(AptoGridColumnDirective.prototype, "colClass", {
        get: /**
         * @return {?}
         */
        function () {
            return this._getClass();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AptoGridColumnDirective.prototype._getClass = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var classes = [];
        if (this.xs) {
            classes.push(this._parseAttribute(this.xs, ''));
        }
        if (this.sm) {
            classes.push(this._parseAttribute(this.sm, 'sm'));
        }
        if (this.md) {
            classes.push(this._parseAttribute(this.md, 'md'));
        }
        if (this.lg) {
            classes.push(this._parseAttribute(this.lg, 'lg'));
        }
        if (this.xl) {
            classes.push(this._parseAttribute(this.xl, 'xl'));
        }
        if (classes.length) {
            return classes.join(' ');
        }
        return 'AptoCol';
    };
    /**
     * @param {?} count
     * @param {?} size
     * @return {?}
     */
    AptoGridColumnDirective.prototype._parseAttribute = /**
     * @param {?} count
     * @param {?} size
     * @return {?}
     */
    function (count, size) {
        if (size !== '') {
            size = "-" + size;
        }
        if (count === 'true' || count === true) {
            return "AptoCol" + size;
        }
        else {
            return "AptoCol" + size + "-" + count;
        }
    };
    AptoGridColumnDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[apto-col],apto-col'
                },] }
    ];
    AptoGridColumnDirective.propDecorators = {
        xs: [{ type: Input }],
        sm: [{ type: Input }],
        md: [{ type: Input }],
        lg: [{ type: Input }],
        xl: [{ type: Input }],
        colClass: [{ type: HostBinding, args: ['class',] }]
    };
    return AptoGridColumnDirective;
}());
var AptoGridRowComponent = /** @class */ (function () {
    function AptoGridRowComponent() {
        this._noGutter = false;
    }
    Object.defineProperty(AptoGridRowComponent.prototype, "noGutter", {
        get: /**
         * @return {?}
         */
        function () {
            return this._noGutter;
        },
        set: /**
         * @param {?} noGutter
         * @return {?}
         */
        function (noGutter) {
            this._noGutter = coerceBooleanProperty(noGutter);
        },
        enumerable: true,
        configurable: true
    });
    AptoGridRowComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-row',
                    template: '<ng-content select="apto-col"></ng-content>',
                    host: {
                        'class': 'AptoRow',
                        '[class.AptoRow--noGutter]': 'noGutter'
                    },
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".AptoRow{display:flex;flex-wrap:wrap;margin-right:-10px;margin-left:-10px;box-sizing:border-box}.AptoRow--noGutter{margin-right:0;margin-left:0}.AptoRow--noGutter>.AptoCol,.AptoRow--noGutter>[class*=AptoCol-]{padding-right:0;padding-left:0}.AptoCol,.AptoCol-1,.AptoCol-10,.AptoCol-11,.AptoCol-12,.AptoCol-2,.AptoCol-3,.AptoCol-4,.AptoCol-5,.AptoCol-6,.AptoCol-7,.AptoCol-8,.AptoCol-9,.AptoCol-auto,.AptoCol-lg,.AptoCol-lg-1,.AptoCol-lg-10,.AptoCol-lg-11,.AptoCol-lg-12,.AptoCol-lg-2,.AptoCol-lg-3,.AptoCol-lg-4,.AptoCol-lg-5,.AptoCol-lg-6,.AptoCol-lg-7,.AptoCol-lg-8,.AptoCol-lg-9,.AptoCol-lg-auto,.AptoCol-md,.AptoCol-md-1,.AptoCol-md-10,.AptoCol-md-11,.AptoCol-md-12,.AptoCol-md-2,.AptoCol-md-3,.AptoCol-md-4,.AptoCol-md-5,.AptoCol-md-6,.AptoCol-md-7,.AptoCol-md-8,.AptoCol-md-9,.AptoCol-md-auto,.AptoCol-sm,.AptoCol-sm-1,.AptoCol-sm-10,.AptoCol-sm-11,.AptoCol-sm-12,.AptoCol-sm-2,.AptoCol-sm-3,.AptoCol-sm-4,.AptoCol-sm-5,.AptoCol-sm-6,.AptoCol-sm-7,.AptoCol-sm-8,.AptoCol-sm-9,.AptoCol-sm-auto,.AptoCol-xl,.AptoCol-xl-1,.AptoCol-xl-10,.AptoCol-xl-11,.AptoCol-xl-12,.AptoCol-xl-2,.AptoCol-xl-3,.AptoCol-xl-4,.AptoCol-xl-5,.AptoCol-xl-6,.AptoCol-xl-7,.AptoCol-xl-8,.AptoCol-xl-9,.AptoCol-xl-auto{position:relative;width:100%;min-height:1px;padding-right:10px;padding-left:10px;box-sizing:border-box}.AptoCol{flex-basis:0;flex-grow:1;max-width:100%}.AptoCol-auto{flex:0 0 auto;width:auto;max-width:none}.AptoCol-1{flex:0 0 8.33333%;max-width:8.33333%}.AptoCol-2{flex:0 0 16.66667%;max-width:16.66667%}.AptoCol-3{flex:0 0 25%;max-width:25%}.AptoCol-4{flex:0 0 33.33333%;max-width:33.33333%}.AptoCol-5{flex:0 0 41.66667%;max-width:41.66667%}.AptoCol-6{flex:0 0 50%;max-width:50%}.AptoCol-7{flex:0 0 58.33333%;max-width:58.33333%}.AptoCol-8{flex:0 0 66.66667%;max-width:66.66667%}.AptoCol-9{flex:0 0 75%;max-width:75%}.AptoCol-10{flex:0 0 83.33333%;max-width:83.33333%}.AptoCol-11{flex:0 0 91.66667%;max-width:91.66667%}.AptoCol-12{flex:0 0 100%;max-width:100%}@media (min-width:576px){.AptoCol-sm{flex-basis:0;flex-grow:1;max-width:100%}.AptoCol-sm-auto{flex:0 0 auto;width:auto;max-width:none}.AptoCol-sm-1{flex:0 0 8.33333%;max-width:8.33333%}.AptoCol-sm-2{flex:0 0 16.66667%;max-width:16.66667%}.AptoCol-sm-3{flex:0 0 25%;max-width:25%}.AptoCol-sm-4{flex:0 0 33.33333%;max-width:33.33333%}.AptoCol-sm-5{flex:0 0 41.66667%;max-width:41.66667%}.AptoCol-sm-6{flex:0 0 50%;max-width:50%}.AptoCol-sm-7{flex:0 0 58.33333%;max-width:58.33333%}.AptoCol-sm-8{flex:0 0 66.66667%;max-width:66.66667%}.AptoCol-sm-9{flex:0 0 75%;max-width:75%}.AptoCol-sm-10{flex:0 0 83.33333%;max-width:83.33333%}.AptoCol-sm-11{flex:0 0 91.66667%;max-width:91.66667%}.AptoCol-sm-12{flex:0 0 100%;max-width:100%}}@media (min-width:768px){.AptoCol-md{flex-basis:0;flex-grow:1;max-width:100%}.AptoCol-md-auto{flex:0 0 auto;width:auto;max-width:none}.AptoCol-md-1{flex:0 0 8.33333%;max-width:8.33333%}.AptoCol-md-2{flex:0 0 16.66667%;max-width:16.66667%}.AptoCol-md-3{flex:0 0 25%;max-width:25%}.AptoCol-md-4{flex:0 0 33.33333%;max-width:33.33333%}.AptoCol-md-5{flex:0 0 41.66667%;max-width:41.66667%}.AptoCol-md-6{flex:0 0 50%;max-width:50%}.AptoCol-md-7{flex:0 0 58.33333%;max-width:58.33333%}.AptoCol-md-8{flex:0 0 66.66667%;max-width:66.66667%}.AptoCol-md-9{flex:0 0 75%;max-width:75%}.AptoCol-md-10{flex:0 0 83.33333%;max-width:83.33333%}.AptoCol-md-11{flex:0 0 91.66667%;max-width:91.66667%}.AptoCol-md-12{flex:0 0 100%;max-width:100%}}@media (min-width:992px){.AptoCol-lg{flex-basis:0;flex-grow:1;max-width:100%}.AptoCol-lg-auto{flex:0 0 auto;width:auto;max-width:none}.AptoCol-lg-1{flex:0 0 8.33333%;max-width:8.33333%}.AptoCol-lg-2{flex:0 0 16.66667%;max-width:16.66667%}.AptoCol-lg-3{flex:0 0 25%;max-width:25%}.AptoCol-lg-4{flex:0 0 33.33333%;max-width:33.33333%}.AptoCol-lg-5{flex:0 0 41.66667%;max-width:41.66667%}.AptoCol-lg-6{flex:0 0 50%;max-width:50%}.AptoCol-lg-7{flex:0 0 58.33333%;max-width:58.33333%}.AptoCol-lg-8{flex:0 0 66.66667%;max-width:66.66667%}.AptoCol-lg-9{flex:0 0 75%;max-width:75%}.AptoCol-lg-10{flex:0 0 83.33333%;max-width:83.33333%}.AptoCol-lg-11{flex:0 0 91.66667%;max-width:91.66667%}.AptoCol-lg-12{flex:0 0 100%;max-width:100%}}@media (min-width:1200px){.AptoCol-xl{flex-basis:0;flex-grow:1;max-width:100%}.AptoCol-xl-auto{flex:0 0 auto;width:auto;max-width:none}.AptoCol-xl-1{flex:0 0 8.33333%;max-width:8.33333%}.AptoCol-xl-2{flex:0 0 16.66667%;max-width:16.66667%}.AptoCol-xl-3{flex:0 0 25%;max-width:25%}.AptoCol-xl-4{flex:0 0 33.33333%;max-width:33.33333%}.AptoCol-xl-5{flex:0 0 41.66667%;max-width:41.66667%}.AptoCol-xl-6{flex:0 0 50%;max-width:50%}.AptoCol-xl-7{flex:0 0 58.33333%;max-width:58.33333%}.AptoCol-xl-8{flex:0 0 66.66667%;max-width:66.66667%}.AptoCol-xl-9{flex:0 0 75%;max-width:75%}.AptoCol-xl-10{flex:0 0 83.33333%;max-width:83.33333%}.AptoCol-xl-11{flex:0 0 91.66667%;max-width:91.66667%}.AptoCol-xl-12{flex:0 0 100%;max-width:100%}}"]
                }] }
    ];
    AptoGridRowComponent.propDecorators = {
        noGutter: [{ type: Input }]
    };
    return AptoGridRowComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoGridContainerComponent = /** @class */ (function () {
    function AptoGridContainerComponent() {
        this._scroll = false;
        this._fixed = false;
    }
    Object.defineProperty(AptoGridContainerComponent.prototype, "scroll", {
        get: /**
         * @return {?}
         */
        function () {
            return this._scroll;
        },
        set: /**
         * @param {?} scroll
         * @return {?}
         */
        function (scroll) {
            this._scroll = coerceBooleanProperty(scroll);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AptoGridContainerComponent.prototype, "fixed", {
        get: /**
         * @return {?}
         */
        function () {
            return this._fixed;
        },
        set: /**
         * @param {?} fixed
         * @return {?}
         */
        function (fixed) {
            this._fixed = coerceBooleanProperty(fixed);
        },
        enumerable: true,
        configurable: true
    });
    AptoGridContainerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-container',
                    template: '<ng-content></ng-content>',
                    host: {
                        'class': 'AptoContainer',
                        '[class.AptoContainer--scroll]': 'scroll',
                        '[class.AptoContainer--fixed]': 'fixed'
                    },
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".AptoContainer{display:block;position:relative;width:100%;padding-right:10px;padding-left:10px;margin-right:auto;margin-left:auto;box-sizing:border-box}@media (min-width:576px){.AptoContainer.AptoContainer--fixed{max-width:540px}}@media (min-width:768px){.AptoContainer.AptoContainer--fixed{max-width:720px}}@media (min-width:992px){.AptoContainer.AptoContainer--fixed{max-width:960px}}@media (min-width:1200px){.AptoContainer.AptoContainer--fixed{max-width:1140px}}.AptoContainer.AptoContainer--scroll{height:100%;overflow-y:auto}"]
                }] }
    ];
    AptoGridContainerComponent.propDecorators = {
        scroll: [{ type: Input }],
        fixed: [{ type: Input }]
    };
    return AptoGridContainerComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoGridComponentModule = /** @class */ (function () {
    function AptoGridComponentModule() {
    }
    AptoGridComponentModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        AptoGridContainerComponent,
                        AptoGridColumnDirective,
                        AptoGridRowComponent
                    ],
                    exports: [
                        AptoGridContainerComponent,
                        AptoGridColumnDirective,
                        AptoGridRowComponent
                    ]
                },] }
    ];
    return AptoGridComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoHeaderComponent = /** @class */ (function () {
    function AptoHeaderComponent() {
        this.type = 1;
    }
    AptoHeaderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-header',
                    template: "<ng-template #headerContent><ng-content></ng-content></ng-template>\n<h1 *ngIf=\"type == 1\" class=\"AptoHeader AptoHeader--h1\">\n    <ng-container [ngTemplateOutlet]=\"headerContent\"></ng-container>\n</h1>\n<h2 *ngIf=\"type == 2\" class=\"AptoHeader AptoHeader--h2\">\n    <ng-container [ngTemplateOutlet]=\"headerContent\"></ng-container>\n</h2>\n<h3 *ngIf=\"type == 3\" class=\"AptoHeader AptoHeader--h3\">\n    <ng-container [ngTemplateOutlet]=\"headerContent\"></ng-container>\n</h3>\n<h4 *ngIf=\"type == 4\" class=\"AptoHeader AptoHeader--h4\">\n    <ng-container [ngTemplateOutlet]=\"headerContent\"></ng-container>\n</h4>\n<h5 *ngIf=\"type == 5\" class=\"AptoHeader AptoHeader--h5\">\n    <ng-container [ngTemplateOutlet]=\"headerContent\"></ng-container>\n</h5>\n<h6 *ngIf=\"type == 6\" class=\"AptoHeader AptoHeader--h6\">\n    <ng-container [ngTemplateOutlet]=\"headerContent\"></ng-container>\n</h6>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".AptoHeader{font-family:\"Open Sans\",sans-serif;display:block;line-height:1.5;margin:0;padding:0}.AptoHeader.AptoHeader--h1{font-size:2.2rem;font-weight:400;text-transform:uppercase}.AptoHeader.AptoHeader--h2{font-size:1.8rem;font-weight:400;text-transform:uppercase}.AptoHeader.AptoHeader--h3{font-size:1.4rem;font-weight:700}.AptoHeader.AptoHeader--h4,.AptoHeader.AptoHeader--h5,.AptoHeader.AptoHeader--h6{font-size:1.2rem;font-weight:700}"]
                }] }
    ];
    AptoHeaderComponent.propDecorators = {
        type: [{ type: Input }]
    };
    return AptoHeaderComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoHeaderComponentModule = /** @class */ (function () {
    function AptoHeaderComponentModule() {
    }
    AptoHeaderComponentModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        AptoHeaderComponent
                    ],
                    exports: [
                        AptoHeaderComponent
                    ]
                },] }
    ];
    return AptoHeaderComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Returns an exception to be thrown in the case when attempting to
 * load an icon with a name that cannot be found.
 * @param {?} iconName
 * @return {?}
 */
function getAptoIconNameNotFoundError(iconName) {
    return Error("Unable to find icon with the name \"" + iconName + "\"");
}
/**
 * Returns an exception to be thrown when the consumer attempts to use
 * `<apto-icon>` without including \@angular/http.
 * @return {?}
 */
function getAptoIconNoHttpProviderError() {
    return Error("Could not find HttpClient provider for use with Apto Icons. " +
        "Please include the HttpClientModule from @angular/common/http in your " +
        "app imports.");
}
/**
 * Returns an exception to be thrown when a URL couldn't be sanitized.
 * @param {?} url URL that was attempted to be sanitized.
 * @return {?}
 */
function getAptoIconFailedToSanitizeUrlError(url) {
    return Error("The URL provided to AptoIconRegistry was not trusted as a resource URL " +
        ("via Angular's DomSanitizer. Attempted URL was " + url + "."));
}
/**
 * Returns an exception to be thrown when a HTML string couldn't be sanitized.
 * @param {?} literal HTML that was attempted to be sanitized.
 * @return {?}
 */
function getAptoIconFailedToSanitizeLiteralError(literal) {
    return Error("The literal provided to AptoIconRegistry was not trusted as safe HTML by " +
        ("Angular's DomSanitizer. Attempted literal was " + literal + "."));
}
/**
 * Configuration for an icon, including the URL and possibly the cached SVG element.
 */
var /**
 * Configuration for an icon, including the URL and possibly the cached SVG element.
 */
SvgIconConfig = /** @class */ (function () {
    function SvgIconConfig(data) {
        // Note that we can't use `instanceof SVGElement` here,
        // because it'll break during server-side rendering.
        if (!!(/** @type {?} */ (data)).nodeName) {
            this.svgElement = /** @type {?} */ (data);
        }
        else {
            this.url = /** @type {?} */ (data);
        }
    }
    return SvgIconConfig;
}());
/**
 * Service to register and display icons used by the `<apto-icon>` component.
 * - Registers icon URLs by namespace and name.
 * - Registers icon set URLs by namespace.
 * - Loads icons from URLs and extracts individual icons from icon sets.
 */
var AptoIconRegistry = /** @class */ (function () {
    function AptoIconRegistry(_httpClient, _sanitizer, document) {
        this._httpClient = _httpClient;
        this._sanitizer = _sanitizer;
        this._supressErrors = false;
        /**
         * URLs and cached SVG elements for individual icons. Keys are of the format "[namespace]:[icon]".
         */
        this._svgIconConfigs = new Map();
        /**
         * SvgIconConfig objects and cached SVG elements for icon sets, keyed by namespace.
         * Multiple icon sets can be registered under the same namespace.
         */
        this._iconSetConfigs = new Map();
        /**
         * Cache for icons loaded by direct URLs.
         */
        this._cachedIconsByUrl = new Map();
        /**
         * In-progress icon fetches. Used to coalesce multiple requests to the same URL.
         */
        this._inProgressUrlFetches = new Map();
        this._document = document;
    }
    /**
     * @param {?} state
     * @return {?}
     */
    AptoIconRegistry.prototype.setErrorSupression = /**
     * @param {?} state
     * @return {?}
     */
    function (state) {
        this._supressErrors = state;
    };
    /**
     * Registers an icon by URL in the default namespace.
     * @param {?} iconName Name under which the icon should be registered.
     * @param {?} url
     * @return {?}
     */
    AptoIconRegistry.prototype.addSvgIcon = /**
     * Registers an icon by URL in the default namespace.
     * @param {?} iconName Name under which the icon should be registered.
     * @param {?} url
     * @return {?}
     */
    function (iconName, url) {
        return this.addSvgIconInNamespace('', iconName, url);
    };
    /**
     * Registers an icon by URL in the specified namespace.
     * @param {?} namespace Namespace in which the icon should be registered.
     * @param {?} iconName Name under which the icon should be registered.
     * @param {?} url
     * @return {?}
     */
    AptoIconRegistry.prototype.addSvgIconInNamespace = /**
     * Registers an icon by URL in the specified namespace.
     * @param {?} namespace Namespace in which the icon should be registered.
     * @param {?} iconName Name under which the icon should be registered.
     * @param {?} url
     * @return {?}
     */
    function (namespace, iconName, url) {
        return this._addSvgIconConfig(namespace, iconName, new SvgIconConfig(url));
    };
    /**
     * Registers an icon set by URL in the default namespace.
     * @param {?} url
     * @return {?}
     */
    AptoIconRegistry.prototype.addSvgIconSet = /**
     * Registers an icon set by URL in the default namespace.
     * @param {?} url
     * @return {?}
     */
    function (url) {
        return this.addSvgIconSetInNamespace('', url);
    };
    /**
     * Registers an icon set by URL in the specified namespace.
     * @param {?} namespace Namespace in which to register the icon set.
     * @param {?} url
     * @return {?}
     */
    AptoIconRegistry.prototype.addSvgIconSetInNamespace = /**
     * Registers an icon set by URL in the specified namespace.
     * @param {?} namespace Namespace in which to register the icon set.
     * @param {?} url
     * @return {?}
     */
    function (namespace, url) {
        return this._addSvgIconSetConfig(namespace, new SvgIconConfig(url));
    };
    /**
     * Returns an Observable that produces the icon (as an `<svg>` DOM element) from the given URL.
     * The response from the URL may be cached so this will not always cause an HTTP request, but
     * the produced element will always be a new copy of the originally fetched icon. (That is,
     * it will not contain any modifications made to elements previously returned).
     *
     * @param {?} safeUrl URL from which to fetch the SVG icon.
     * @return {?}
     */
    AptoIconRegistry.prototype.getSvgIconFromUrl = /**
     * Returns an Observable that produces the icon (as an `<svg>` DOM element) from the given URL.
     * The response from the URL may be cached so this will not always cause an HTTP request, but
     * the produced element will always be a new copy of the originally fetched icon. (That is,
     * it will not contain any modifications made to elements previously returned).
     *
     * @param {?} safeUrl URL from which to fetch the SVG icon.
     * @return {?}
     */
    function (safeUrl) {
        var _this = this;
        /** @type {?} */
        var url = this._sanitizer.sanitize(SecurityContext.RESOURCE_URL, safeUrl);
        if (!url) {
            throw getAptoIconFailedToSanitizeUrlError(safeUrl);
        }
        /** @type {?} */
        var cachedIcon = this._cachedIconsByUrl.get(url);
        if (cachedIcon) {
            return of(cloneSvg(cachedIcon));
        }
        return this._loadSvgIconFromConfig(new SvgIconConfig(safeUrl)).pipe(tap(function (svg) { return _this._cachedIconsByUrl.set(/** @type {?} */ ((url)), svg); }), // tslint:disable-line
        // tslint:disable-line
        map(function (svg) { return cloneSvg(svg); }));
    };
    /**
     * Returns an Observable that produces the icon (as an `<svg>` DOM element) with the given name
     * and namespace. The icon must have been previously registered with addIcon or addIconSet;
     * if not, the Observable will throw an error.
     *
     * @param {?} name Name of the icon to be retrieved.
     * @param {?=} namespace Namespace in which to look for the icon.
     * @return {?}
     */
    AptoIconRegistry.prototype.getNamedSvgIcon = /**
     * Returns an Observable that produces the icon (as an `<svg>` DOM element) with the given name
     * and namespace. The icon must have been previously registered with addIcon or addIconSet;
     * if not, the Observable will throw an error.
     *
     * @param {?} name Name of the icon to be retrieved.
     * @param {?=} namespace Namespace in which to look for the icon.
     * @return {?}
     */
    function (name, namespace) {
        if (namespace === void 0) { namespace = ''; }
        /** @type {?} */
        var key = iconKey(namespace, name);
        /** @type {?} */
        var config = this._svgIconConfigs.get(key);
        if (config) {
            return this._getSvgFromConfig(config);
        }
        /** @type {?} */
        var iconSetConfigs = this._iconSetConfigs.get(namespace);
        if (iconSetConfigs) {
            return this._getSvgFromIconSetConfigs(name, iconSetConfigs);
        }
        if (this._supressErrors) {
            return this._getEmptySvg();
        }
        return throwError(getAptoIconNameNotFoundError(key));
    };
    /**
     * Returns the cached icon for a SvgIconConfig if available, or fetches it from its URL if not.
     * @param {?} config
     * @return {?}
     */
    AptoIconRegistry.prototype._getSvgFromConfig = /**
     * Returns the cached icon for a SvgIconConfig if available, or fetches it from its URL if not.
     * @param {?} config
     * @return {?}
     */
    function (config) {
        if (config.svgElement) {
            // We already have the SVG element for this icon, return a copy.
            return of(cloneSvg(config.svgElement));
        }
        else {
            // Fetch the icon from the config's URL, cache it, and return a copy.
            return this._loadSvgIconFromConfig(config).pipe(tap(function (svg) { return (config.svgElement = svg); }), map(function (svg) { return cloneSvg(svg); }));
        }
    };
    /**
     * Attempts to find an icon with the specified name in any of the SVG icon sets.
     * First searches the available cached icons for a nested element with a matching name, and
     * if found copies the element to a new `<svg>` element. If not found, fetches all icon sets
     * that have not been cached, and searches again after all fetches are completed.
     * The returned Observable produces the SVG element if possible, and throws
     * an error if no icon with the specified name can be found.
     * @param {?} name
     * @param {?} iconSetConfigs
     * @return {?}
     */
    AptoIconRegistry.prototype._getSvgFromIconSetConfigs = /**
     * Attempts to find an icon with the specified name in any of the SVG icon sets.
     * First searches the available cached icons for a nested element with a matching name, and
     * if found copies the element to a new `<svg>` element. If not found, fetches all icon sets
     * that have not been cached, and searches again after all fetches are completed.
     * The returned Observable produces the SVG element if possible, and throws
     * an error if no icon with the specified name can be found.
     * @param {?} name
     * @param {?} iconSetConfigs
     * @return {?}
     */
    function (name, iconSetConfigs) {
        var _this = this;
        /** @type {?} */
        var namedIcon = this._extractIconWithNameFromAnySet(name, iconSetConfigs);
        if (namedIcon) {
            // We could cache namedIcon in _svgIconConfigs, but since we have to make a copy every
            // time anyway, there's probably not much advantage compared to just always extracting
            // it from the icon set.
            return of(namedIcon);
        }
        /** @type {?} */
        var iconSetFetchRequests = iconSetConfigs
            .filter(function (iconSetConfig) { return !iconSetConfig.svgElement; })
            .map(function (iconSetConfig) {
            return _this._loadSvgIconSetFromConfig(iconSetConfig).pipe(catchError(function (err) {
                /** @type {?} */
                var url = _this._sanitizer.sanitize(SecurityContext.RESOURCE_URL, iconSetConfig.url);
                // Swallow errors fetching individual URLs so the
                // combined Observable won't necessarily fail.
                console.error("Loading icon set URL: " + url + " failed: " + err.message);
                return of(null);
            }));
        });
        // Fetch all the icon set URLs. When the requests complete, every IconSet should have a
        // cached SVG element (unless the request failed), and we can check again for the icon.
        return forkJoin(iconSetFetchRequests).pipe(map(function () {
            /** @type {?} */
            var foundIcon = _this._extractIconWithNameFromAnySet(name, iconSetConfigs);
            if (!foundIcon) {
                throw getAptoIconNameNotFoundError(name);
            }
            return foundIcon;
        }));
    };
    /**
     * Searches the cached SVG elements for the given icon sets for a nested icon element whose "id"
     * tag matches the specified name. If found, copies the nested element to a new SVG element and
     * returns it. Returns null if no matching element is found.
     * @param {?} iconName
     * @param {?} iconSetConfigs
     * @return {?}
     */
    AptoIconRegistry.prototype._extractIconWithNameFromAnySet = /**
     * Searches the cached SVG elements for the given icon sets for a nested icon element whose "id"
     * tag matches the specified name. If found, copies the nested element to a new SVG element and
     * returns it. Returns null if no matching element is found.
     * @param {?} iconName
     * @param {?} iconSetConfigs
     * @return {?}
     */
    function (iconName, iconSetConfigs) {
        // Iterate backwards, so icon sets added later have precedence.
        for (var i = iconSetConfigs.length - 1; i >= 0; i--) {
            /** @type {?} */
            var config = iconSetConfigs[i];
            if (config.svgElement) {
                /** @type {?} */
                var foundIcon = this._extractSvgIconFromSet(config.svgElement, iconName);
                if (foundIcon) {
                    return foundIcon;
                }
            }
        }
        return null;
    };
    /**
     * Loads the content of the icon URL specified in the SvgIconConfig and creates an SVG element
     * from it.
     * @param {?} config
     * @return {?}
     */
    AptoIconRegistry.prototype._loadSvgIconFromConfig = /**
     * Loads the content of the icon URL specified in the SvgIconConfig and creates an SVG element
     * from it.
     * @param {?} config
     * @return {?}
     */
    function (config) {
        var _this = this;
        return this._fetchUrl(config.url).pipe(map(function (svgText) { return _this._createSvgElementForSingleIcon(svgText); }));
    };
    /**
     * Loads the content of the icon set URL specified in the SvgIconConfig and creates an SVG element
     * from it.
     * @param {?} config
     * @return {?}
     */
    AptoIconRegistry.prototype._loadSvgIconSetFromConfig = /**
     * Loads the content of the icon set URL specified in the SvgIconConfig and creates an SVG element
     * from it.
     * @param {?} config
     * @return {?}
     */
    function (config) {
        var _this = this;
        // If the SVG for this icon set has already been parsed, do nothing.
        if (config.svgElement) {
            return of(config.svgElement);
        }
        return this._fetchUrl(config.url).pipe(map(function (svgText) {
            // It is possible that the icon set was parsed and cached by an earlier request, so parsing
            // only needs to occur if the cache is yet unset.
            if (!config.svgElement) {
                config.svgElement = _this._svgElementFromString(svgText);
            }
            return config.svgElement;
        }));
    };
    /**
     * Creates a DOM element from the given SVG string, and adds default attributes.
     * @param {?} responseText
     * @return {?}
     */
    AptoIconRegistry.prototype._createSvgElementForSingleIcon = /**
     * Creates a DOM element from the given SVG string, and adds default attributes.
     * @param {?} responseText
     * @return {?}
     */
    function (responseText) {
        /** @type {?} */
        var svg = this._svgElementFromString(responseText);
        this._setSvgAttributes(svg);
        return svg;
    };
    /**
     * Searches the cached element of the given SvgIconConfig for a nested icon element whose "id"
     * tag matches the specified name. If found, copies the nested element to a new SVG element and
     * returns it. Returns null if no matching element is found.
     * @param {?} iconSet
     * @param {?} iconName
     * @return {?}
     */
    AptoIconRegistry.prototype._extractSvgIconFromSet = /**
     * Searches the cached element of the given SvgIconConfig for a nested icon element whose "id"
     * tag matches the specified name. If found, copies the nested element to a new SVG element and
     * returns it. Returns null if no matching element is found.
     * @param {?} iconSet
     * @param {?} iconName
     * @return {?}
     */
    function (iconSet, iconName) {
        /** @type {?} */
        var iconSource = iconSet.querySelector("#" + iconName);
        if (!iconSource) {
            return null;
        }
        /** @type {?} */
        var iconElement = /** @type {?} */ (iconSource.cloneNode(true));
        iconElement.removeAttribute('id');
        // If the icon node is itself an <svg> node, clone and return it directly. If not, set it as
        // the content of a new <svg> node.
        if (iconElement.nodeName.toLowerCase() === 'svg') {
            return this._setSvgAttributes(/** @type {?} */ (iconElement));
        }
        // If the node is a <symbol>, it won't be rendered so we have to convert it into <svg>. Note
        // that the same could be achieved by referring to it via <use href="#id">, however the <use>
        // tag is problematic on Firefox, because it needs to include the current page path.
        if (iconElement.nodeName.toLowerCase() === 'symbol') {
            return this._setSvgAttributes(this._toSvgElement(iconElement));
        }
        /** @type {?} */
        var svg = this._svgElementFromString('<svg></svg>');
        // Clone the node so we don't remove it from the parent icon set element.
        svg.appendChild(iconElement);
        return this._setSvgAttributes(svg);
    };
    /**
     * Creates a DOM element from the given SVG string.
     * @param {?} str
     * @return {?}
     */
    AptoIconRegistry.prototype._svgElementFromString = /**
     * Creates a DOM element from the given SVG string.
     * @param {?} str
     * @return {?}
     */
    function (str) {
        /** @type {?} */
        var div = this._document.createElement('DIV');
        div.innerHTML = str;
        /** @type {?} */
        var svg = /** @type {?} */ (div.querySelector('svg'));
        if (!svg) {
            throw Error('<svg> tag not found');
        }
        return svg;
    };
    /**
     * Converts an element into an SVG node by cloning all of its children.
     * @param {?} element
     * @return {?}
     */
    AptoIconRegistry.prototype._toSvgElement = /**
     * Converts an element into an SVG node by cloning all of its children.
     * @param {?} element
     * @return {?}
     */
    function (element) {
        /** @type {?} */
        var svg = this._svgElementFromString('<svg></svg>');
        for (var i = 0; i < element.childNodes.length; i++) {
            if (element.childNodes[i].nodeType === this._document.ELEMENT_NODE) {
                svg.appendChild(element.childNodes[i].cloneNode(true));
            }
        }
        return svg;
    };
    /**
     * Sets the default attributes for an SVG element to be used as an icon.
     * @param {?} svg
     * @return {?}
     */
    AptoIconRegistry.prototype._setSvgAttributes = /**
     * Sets the default attributes for an SVG element to be used as an icon.
     * @param {?} svg
     * @return {?}
     */
    function (svg) {
        svg.setAttribute('fit', '');
        svg.setAttribute('height', '100%');
        svg.setAttribute('width', '100%');
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        svg.removeAttribute('y');
        svg.removeAttribute('x');
        svg.setAttribute('focusable', 'false');
        return svg;
    };
    /**
     * Returns an Observable which produces the string contents of the given URL. Results may be
     * cached, so future calls with the same URL may not cause another HTTP request.
     * @param {?} safeUrl
     * @return {?}
     */
    AptoIconRegistry.prototype._fetchUrl = /**
     * Returns an Observable which produces the string contents of the given URL. Results may be
     * cached, so future calls with the same URL may not cause another HTTP request.
     * @param {?} safeUrl
     * @return {?}
     */
    function (safeUrl) {
        var _this = this;
        if (!this._httpClient) {
            throw getAptoIconNoHttpProviderError();
        }
        if (safeUrl == null) {
            throw Error("Cannot fetch icon from URL \"" + safeUrl + "\".");
        }
        /** @type {?} */
        var url = this._sanitizer.sanitize(SecurityContext.RESOURCE_URL, safeUrl);
        if (!url) {
            throw getAptoIconFailedToSanitizeUrlError(safeUrl);
        }
        /** @type {?} */
        var inProgressFetch = this._inProgressUrlFetches.get(url);
        if (inProgressFetch) {
            return inProgressFetch;
        }
        /** @type {?} */
        var req = this._httpClient.get(url, { responseType: 'text' }).pipe(finalize(function () { return _this._inProgressUrlFetches.delete(url); }), share());
        this._inProgressUrlFetches.set(url, req);
        return req;
    };
    /**
     * Registers an icon config by name in the specified namespace.
     * @param {?} namespace Namespace in which to register the icon config.
     * @param {?} iconName Name under which to register the config.
     * @param {?} config Config to be registered.
     * @return {?}
     */
    AptoIconRegistry.prototype._addSvgIconConfig = /**
     * Registers an icon config by name in the specified namespace.
     * @param {?} namespace Namespace in which to register the icon config.
     * @param {?} iconName Name under which to register the config.
     * @param {?} config Config to be registered.
     * @return {?}
     */
    function (namespace, iconName, config) {
        this._svgIconConfigs.set(iconKey(namespace, iconName), config);
        return this;
    };
    /**
     * Registers an icon set config in the specified namespace.
     * @param {?} namespace Namespace in which to register the icon config.
     * @param {?} config Config to be registered.
     * @return {?}
     */
    AptoIconRegistry.prototype._addSvgIconSetConfig = /**
     * Registers an icon set config in the specified namespace.
     * @param {?} namespace Namespace in which to register the icon config.
     * @param {?} config Config to be registered.
     * @return {?}
     */
    function (namespace, config) {
        /** @type {?} */
        var configNamespace = this._iconSetConfigs.get(namespace);
        if (configNamespace) {
            configNamespace.push(config);
        }
        else {
            this._iconSetConfigs.set(namespace, [config]);
        }
        return this;
    };
    /**
     * @return {?}
     */
    AptoIconRegistry.prototype._getEmptySvg = /**
     * @return {?}
     */
    function () {
        return of(cloneSvg(this._svgElementFromString('<svg></svg>')));
    };
    AptoIconRegistry.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AptoIconRegistry.ctorParameters = function () { return [
        { type: HttpClient, decorators: [{ type: Optional }] },
        { type: DomSanitizer },
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DOCUMENT,] }] }
    ]; };
    return AptoIconRegistry;
}());
/**
 * @param {?} parentRegistry
 * @param {?} httpClient
 * @param {?} sanitizer
 * @param {?=} document
 * @return {?}
 */
function ICON_REGISTRY_PROVIDER_FACTORY(parentRegistry, httpClient, sanitizer, document) {
    return parentRegistry || new AptoIconRegistry(httpClient, sanitizer, document);
}
/** @type {?} */
var ICON_REGISTRY_PROVIDER = {
    // If there is already an AptoIconRegistry available, use that. Otherwise, provide a new one.
    provide: AptoIconRegistry,
    deps: [
        [new Optional(), new SkipSelf(), AptoIconRegistry],
        [new Optional(), HttpClient],
        DomSanitizer,
        [new Optional(), /** @type {?} */ (DOCUMENT)]
    ],
    useFactory: ICON_REGISTRY_PROVIDER_FACTORY
};
/**
 * Clones an SVGElement while preserving type information.
 * @param {?} svg
 * @return {?}
 */
function cloneSvg(svg) {
    return /** @type {?} */ (svg.cloneNode(true));
}
/**
 * Returns the cache key to use for an icon namespace and name.
 * @param {?} namespace
 * @param {?} name
 * @return {?}
 */
function iconKey(namespace, name) {
    return namespace + ":" + name;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
var IconColors = {
    white: 'white',
    blue: 'blue',
    orange: 'orange',
    gray: 'gray',
    lightGray: 'lightGray',
};
/** @enum {string} */
var IconStatus = {
    warning: 'warning',
    danger: 'danger',
};
var AptoIconComponent = /** @class */ (function () {
    function AptoIconComponent(_elementRef, _iconRegistry, ariaHidden) {
        this._elementRef = _elementRef;
        this._iconRegistry = _iconRegistry;
        this.ariaHidden = ariaHidden;
        this.icon = null;
        this.size = null;
        this.circleColor = null;
        this.status = null;
        this._circle = false;
        this._inline = false;
        if (!ariaHidden) {
            this._elementRef.nativeElement.setAttribute('aria-hidden', 'true');
        }
    }
    Object.defineProperty(AptoIconComponent.prototype, "circle", {
        get: /**
         * @return {?}
         */
        function () {
            return this._circle;
        },
        set: /**
         * @param {?} circle
         * @return {?}
         */
        function (circle) {
            this._circle = coerceBooleanProperty(circle);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AptoIconComponent.prototype, "inline", {
        get: /**
         * @return {?}
         */
        function () {
            return this._inline;
        },
        set: /**
         * @param {?} inline
         * @return {?}
         */
        function (inline) {
            this._inline = coerceBooleanProperty(inline);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    AptoIconComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        var _this = this;
        if (changes["icon"]) {
            if (this.icon) {
                var _a = __read(this._splitIconName(this.icon), 2), namespace = _a[0], iconName = _a[1];
                this._iconRegistry.getNamedSvgIcon(iconName, namespace).pipe(take(1)).subscribe(function (svg) { return _this._setSvgElement(svg); }, function (err) { return console.log("Error retrieving icon: " + err.message); });
            }
            else {
                this._clearSvgElement();
            }
        }
        if (changes["circleColor"]) {
            if (changes["circleColor"].previousValue) {
                this._elementRef.nativeElement.classList.remove("AptoIcon--color" + this.capitailize(changes["circleColor"].previousValue));
            }
            this._elementRef.nativeElement.classList.add("AptoIcon--color" + this.capitailize(this.circleColor));
        }
        if (changes["status"]) {
            if (changes["status"].previousValue) {
                this._elementRef.nativeElement.classList.remove("AptoIcon--status" + this.capitailize(changes["status"].previousValue));
            }
            this._elementRef.nativeElement.classList.add("AptoIcon--status" + this.capitailize(this.status));
        }
        if (changes["size"]) {
            if (changes["size"].previousValue) {
                this._elementRef.nativeElement.classList.remove("AptoIcon--size" + changes["size"].previousValue);
            }
            this._elementRef.nativeElement.classList.add("AptoIcon--size" + this.size);
        }
    };
    /**
     * @param {?} str
     * @return {?}
     */
    AptoIconComponent.prototype.capitailize = /**
     * @param {?} str
     * @return {?}
     */
    function (str) {
        return str.charAt(0).toUpperCase() + str.substr(1);
    };
    /**
     * @param {?} iconName
     * @return {?}
     */
    AptoIconComponent.prototype._splitIconName = /**
     * @param {?} iconName
     * @return {?}
     */
    function (iconName) {
        if (!iconName) {
            return ['', ''];
        }
        /** @type {?} */
        var parts = iconName.split(':');
        switch (parts.length) {
            case 1: return ['', parts[0]];
            case 2: return /** @type {?} */ (parts);
            default: throw Error("Invalid icon name: \"" + iconName + "\"");
        }
    };
    /**
     * @param {?} svg
     * @return {?}
     */
    AptoIconComponent.prototype._setSvgElement = /**
     * @param {?} svg
     * @return {?}
     */
    function (svg) {
        this._clearSvgElement();
        this._elementRef.nativeElement.appendChild(svg);
    };
    /**
     * @return {?}
     */
    AptoIconComponent.prototype._clearSvgElement = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var layoutElement = this._elementRef.nativeElement;
        /** @type {?} */
        var childCount = layoutElement.childNodes.length;
        while (childCount--) {
            /** @type {?} */
            var child = layoutElement.childNodes[childCount];
            if (child.nodeType !== 1 || child.nodeName.toLowerCase() === 'svg') {
                layoutElement.removeChild(child);
            }
        }
    };
    AptoIconComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-icon',
                    template: '<ng-content></ng-content><span *ngIf="status" class="AptoIcon-status">!</span>',
                    host: {
                        'class': 'AptoIcon',
                        'role': 'img',
                        '[class.AptoIcon--inline]': 'inline',
                        '[class.AptoIcon--circle]': 'circle'
                    },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".AptoIcon{display:inline-block;fill:currentColor;line-height:0;box-sizing:border-box;position:relative;width:2rem;height:2rem}.AptoIcon.AptoIcon--inline{vertical-align:middle}.AptoIcon.AptoIcon--circle{border-radius:50%;background-color:currentColor;border:3px solid currentColor;fill:#fff}.AptoIcon.AptoIcon--circle:after{content:'';display:table;padding-top:100%}.AptoIcon.AptoIcon--circle.AptoIcon--colorWhite{background-color:#fff;border-color:#fff;fill:#64b5f6}.AptoIcon.AptoIcon--circle.AptoIcon--colorBlue{background-color:#64b5f6;border-color:#64b5f6;fill:#fff}.AptoIcon.AptoIcon--circle.AptoIcon--colorOrange{background-color:#ff9800;border-color:#ff9800;fill:#fff}.AptoIcon.AptoIcon--circle.AptoIcon--colorGray{background-color:#bdbdbd;border-color:#bdbdbd;fill:#fff}.AptoIcon.AptoIcon--circle.AptoIcon--colorLightGray{background-color:#eee;border-color:#eee;fill:#fff}.AptoIcon.AptoIcon--size1{width:1.4rem;height:1.4rem;min-width:1.4rem}.AptoIcon.AptoIcon--size1.AptoIcon--circle{border-width:2px}.AptoIcon.AptoIcon--size2{width:1.8rem;height:1.8rem;min-width:1.8rem}.AptoIcon.AptoIcon--size2.AptoIcon--circle{border-width:2px}.AptoIcon.AptoIcon--size3{width:2rem;height:2rem;min-width:2rem}.AptoIcon.AptoIcon--size3.AptoIcon--circle{border-width:3px}.AptoIcon.AptoIcon--size4{width:2.4rem;height:2.4rem;min-width:2.4rem}.AptoIcon.AptoIcon--size4.AptoIcon--circle{border-width:4px}.AptoIcon.AptoIcon--size5{width:2.8rem;height:2.8rem;min-width:2.8rem}.AptoIcon.AptoIcon--size5.AptoIcon--circle{border-width:5px}.AptoIcon.AptoIcon--size6{width:5rem;height:5rem;min-width:5rem}.AptoIcon.AptoIcon--size6.AptoIcon--circle{border-width:7px}.AptoIcon .AptoIcon-status{color:#fff;display:block;font-family:\"Open Sans\",sans-serif;font-size:9px;font-weight:700;position:absolute;top:-13px;left:-9px;width:0;height:0;border-left:8px solid transparent;border-right:8px solid transparent;border-bottom:13.856px solid #212121;line-height:15px;text-indent:-1.25px}.AptoIcon.AptoIcon--circle.AptoIcon--statusDanger:before,.AptoIcon.AptoIcon--circle.AptoIcon--statusWarning:before{border:3px solid #212121;border-radius:50%;content:'';top:-5px;left:-5px;right:-5px;bottom:-5px;position:absolute}.AptoIcon.AptoIcon--circle.AptoIcon--statusDanger.AptoIcon--size6:before,.AptoIcon.AptoIcon--circle.AptoIcon--statusWarning.AptoIcon--size6:before{top:-7px;left:-7px;right:-7px;bottom:-7px}.AptoIcon.AptoIcon--statusWarning .AptoIcon-status{border-bottom-color:#f6a623}.AptoIcon.AptoIcon--statusWarning:before{border-color:#f6a623!important}.AptoIcon.AptoIcon--statusDanger .AptoIcon-status{border-bottom-color:#dc3545}.AptoIcon.AptoIcon--statusDanger:before{border-color:#dc3545!important}"]
                }] }
    ];
    /** @nocollapse */
    AptoIconComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: AptoIconRegistry },
        { type: String, decorators: [{ type: Attribute, args: ['aria-hidden',] }] }
    ]; };
    AptoIconComponent.propDecorators = {
        icon: [{ type: Input }],
        size: [{ type: Input }],
        circleColor: [{ type: Input }],
        status: [{ type: Input }],
        circle: [{ type: Input }],
        inline: [{ type: Input }]
    };
    return AptoIconComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoIconComponentModule = /** @class */ (function () {
    function AptoIconComponentModule() {
    }
    AptoIconComponentModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        AptoIconComponent
                    ],
                    exports: [
                        AptoIconComponent
                    ]
                },] }
    ];
    return AptoIconComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoListItemIconDirective = /** @class */ (function () {
    function AptoListItemIconDirective() {
    }
    AptoListItemIconDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[apto-list-item-icon], [aptoListItemIcon]',
                    host: { 'class': 'AptoListItem-icon' }
                },] }
    ];
    return AptoListItemIconDirective;
}());
var AptoListItemComponent = /** @class */ (function () {
    function AptoListItemComponent() {
        this._link = false;
        this._empty = false;
        this._active = false;
    }
    Object.defineProperty(AptoListItemComponent.prototype, "link", {
        get: /**
         * @return {?}
         */
        function () {
            return this._link;
        },
        set: /**
         * @param {?} link
         * @return {?}
         */
        function (link) {
            this._link = coerceBooleanProperty(link);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AptoListItemComponent.prototype, "empty", {
        get: /**
         * @return {?}
         */
        function () {
            return this._empty;
        },
        set: /**
         * @param {?} empty
         * @return {?}
         */
        function (empty) {
            this._empty = coerceBooleanProperty(empty);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AptoListItemComponent.prototype, "active", {
        get: /**
         * @return {?}
         */
        function () {
            return this._active;
        },
        set: /**
         * @param {?} active
         * @return {?}
         */
        function (active) {
            this._active = coerceBooleanProperty(active);
        },
        enumerable: true,
        configurable: true
    });
    AptoListItemComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-list-item',
                    template: "<div class=\"AptoListItem-content\">\n    <ng-content select=\"[apto-list-item-icon],[aptoListItemIcon]\"></ng-content>\n    <div class=\"AptoListItem-text\">\n        <ng-content></ng-content>\n    </div>\n</div>\n",
                    host: {
                        'class': 'AptoListItem',
                        '[class.AptoListItem--link]': 'link',
                        '[class.AptoListItem--empty]': 'empty',
                        '[class.AptoListItem--active]': 'active'
                    },
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".AptoListItem{display:block;width:100%;margin:0;padding:0;position:relative;background-color:#fff;box-sizing:border-box}.AptoListItem *{box-sizing:border-box}.AptoListItem.AptoListItem--link{cursor:pointer}.AptoListItem.AptoListItem--link:after{content:\"\";display:inline-block;border-right:2px solid #908e8e;border-bottom:2px solid #908e8e;width:8px;height:8px;position:absolute;right:15px;top:50%;-webkit-transform:rotate(-45deg) translateY(-50%);transform:rotate(-45deg) translateY(-50%)}.AptoListItem.AptoListItem--link .AptoListItem-text{padding-right:3.6rem}.AptoListItem.AptoListItem--empty{color:#bdbdbd}.AptoListItem.AptoListItem--empty .AptoListItem-text{padding-left:3.6rem;padding-right:3.6rem;border-bottom-color:transparent}.AptoListItem.AptoListItem--empty .AptoListItem-icon{margin-left:3.6rem}.AptoListItem.AptoListItem--empty .AptoListItem-icon+.AptoListItem-text{padding-left:1rem}.AptoListItem.AptoListItem--active,.AptoListItem.AptoListItem--link:hover{background-color:#eee}.AptoListItem-content{display:flex;align-items:center}.AptoListItem-text{padding:1.4rem 1.6rem;margin:0;width:100%;overflow:hidden;border-bottom:1px solid #dedede}.AptoListItem-icon{margin:0 0 0 1.6rem}.AptoListItem-icon+.AptoListItem-text{padding-left:1.3rem}"]
                }] }
    ];
    AptoListItemComponent.propDecorators = {
        link: [{ type: Input }],
        empty: [{ type: Input }],
        active: [{ type: Input }]
    };
    return AptoListItemComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoListComponent = /** @class */ (function () {
    function AptoListComponent() {
    }
    AptoListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-list',
                    template: '<ng-content></ng-content>',
                    host: {
                        'class': 'AptoList'
                    },
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".AptoList>:last-child .AptoListItem-text{border-bottom-color:transparent}"]
                }] }
    ];
    return AptoListComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoListComponentModule = /** @class */ (function () {
    function AptoListComponentModule() {
    }
    AptoListComponentModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        AptoListItemIconDirective,
                        AptoListComponent,
                        AptoListItemComponent
                    ],
                    exports: [
                        AptoListItemIconDirective,
                        AptoListComponent,
                        AptoListItemComponent
                    ]
                },] }
    ];
    return AptoListComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoLoaderComponent = /** @class */ (function () {
    function AptoLoaderComponent() {
        this.text = '';
        this._noOverlay = false;
    }
    Object.defineProperty(AptoLoaderComponent.prototype, "noOverlay", {
        get: /**
         * @return {?}
         */
        function () {
            return this._noOverlay;
        },
        set: /**
         * @param {?} noOverlay
         * @return {?}
         */
        function (noOverlay) {
            this._noOverlay = coerceBooleanProperty(noOverlay);
        },
        enumerable: true,
        configurable: true
    });
    AptoLoaderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-loader',
                    template: "<div class=\"AptoLoader-spinner\">\n    <svg viewBox=\"0 0 64 64\">\n        <circle transform=\"translate(32,32)\" r=\"26\"></circle>\n    </svg>\n</div>\n<div *ngIf=\"text\" class=\"AptoLoader-content\">{{ text }}</div>\n",
                    host: {
                        'class': 'AptoLoader',
                        '[class.AptoLoader--noOverlay]': 'noOverlay'
                    },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".AptoLoader{position:absolute;top:0;bottom:0;left:0;right:0;background:rgba(255,255,255,.8);display:flex;justify-content:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.AptoLoader.AptoLoader--noOverlay{background:0 0}.AptoLoader-spinner{position:relative;display:inline-block;width:28px;height:28px;margin-right:10px;vertical-align:middle}.AptoLoader-spinner svg{-webkit-animation:1s linear infinite AptoLoader-rotate;animation:1s linear infinite AptoLoader-rotate}.AptoLoader-spinner circle{fill:transparent;stroke-width:4px;stroke-dasharray:128px;stroke-dashoffset:82px;stroke:#64b5f6}.AptoLoader-content{font-family:\"Open Sans\",sans-serif;font-size:1.4rem;font-weight:500;line-height:1.5;color:#9e9e9e;display:inline-block}@-webkit-keyframes AptoLoader-rotate{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes AptoLoader-rotate{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}"]
                }] }
    ];
    AptoLoaderComponent.propDecorators = {
        text: [{ type: Input }],
        noOverlay: [{ type: Input }]
    };
    return AptoLoaderComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoLoaderComponentModule = /** @class */ (function () {
    function AptoLoaderComponentModule() {
    }
    AptoLoaderComponentModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        AptoLoaderComponent
                    ],
                    exports: [
                        AptoLoaderComponent
                    ]
                },] }
    ];
    return AptoLoaderComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoParagraphComponent = /** @class */ (function () {
    function AptoParagraphComponent() {
        this.compact = false;
    }
    AptoParagraphComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-paragraph',
                    template: "<p class=\"AptoParagraph\"><ng-content></ng-content></p>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".AptoParagraph{font-family:\"Open Sans\",sans-serif;font-size:1.4rem;font-weight:500;line-height:1.5;margin:0;padding:0;display:block}apto-paragraph+apto-paragraph .AptoParagraph{padding-top:10px}apto-paragraph[compact]+apto-paragraph[compact] .AptoParagraph{padding-top:.2rem}"]
                }] }
    ];
    AptoParagraphComponent.propDecorators = {
        compact: [{ type: Input }]
    };
    return AptoParagraphComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoParagraphComponentModule = /** @class */ (function () {
    function AptoParagraphComponentModule() {
    }
    AptoParagraphComponentModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        AptoParagraphComponent
                    ],
                    exports: [
                        AptoParagraphComponent
                    ]
                },] }
    ];
    return AptoParagraphComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoShimmerComponent = /** @class */ (function () {
    function AptoShimmerComponent() {
    }
    AptoShimmerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-shimmer',
                    template: '<ng-content></ng-content>',
                    host: { 'class': 'AptoShimmer' },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: ["@-webkit-keyframes aptoShimmerAnimation{0%{background-position:-468px 0}100%{background-position:468px 0}}@keyframes aptoShimmerAnimation{0%{background-position:-468px 0}100%{background-position:468px 0}}.AptoShimmer{-webkit-animation:2s linear infinite forwards aptoShimmerAnimation;animation:2s linear infinite forwards aptoShimmerAnimation;background:#f5f5f5;background:linear-gradient(to right,#f5f5f5 8%,#e0e0e0 18%,#f5f5f5 33%);background-size:992px 100%;display:inline-block;position:relative;min-height:1.6rem;padding:0;min-width:1.6rem;vertical-align:middle}"]
                }] }
    ];
    return AptoShimmerComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoShimmerComponentModule = /** @class */ (function () {
    function AptoShimmerComponentModule() {
    }
    AptoShimmerComponentModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        AptoShimmerComponent
                    ],
                    exports: [
                        AptoShimmerComponent
                    ]
                },] }
    ];
    return AptoShimmerComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoTabContentDirective = /** @class */ (function () {
    function AptoTabContentDirective(templateRef) {
        this.templateRef = templateRef;
    }
    AptoTabContentDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[aptoTabContent]'
                },] }
    ];
    /** @nocollapse */
    AptoTabContentDirective.ctorParameters = function () { return [
        { type: TemplateRef }
    ]; };
    return AptoTabContentDirective;
}());
var AptoTabLabelDirective = /** @class */ (function () {
    function AptoTabLabelDirective(templateRef) {
        this.templateRef = templateRef;
    }
    AptoTabLabelDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[aptoTabLabel]'
                },] }
    ];
    /** @nocollapse */
    AptoTabLabelDirective.ctorParameters = function () { return [
        { type: TemplateRef }
    ]; };
    return AptoTabLabelDirective;
}());
var AptoTabComponent = /** @class */ (function () {
    function AptoTabComponent() {
        this.label = '';
        this.automation = null;
        this.contentRef = null;
        this.active = false;
    }
    /**
     * @return {?}
     */
    AptoTabComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.contentRef = this._explicitContent || this._implicitContent;
    };
    AptoTabComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-tab',
                    template: "<ng-template><ng-content></ng-content></ng-template>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None
                }] }
    ];
    AptoTabComponent.propDecorators = {
        label: [{ type: Input }],
        automation: [{ type: Input }],
        templateLabel: [{ type: ContentChild, args: [AptoTabLabelDirective,] }],
        _explicitContent: [{ type: ContentChild, args: [AptoTabContentDirective, {
                        read: TemplateRef
                    },] }],
        _implicitContent: [{ type: ViewChild, args: [TemplateRef,] }]
    };
    return AptoTabComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoTabNavComponent = /** @class */ (function () {
    function AptoTabNavComponent() {
    }
    AptoTabNavComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-tab-nav,[aptoTabNav]',
                    template: '<ng-content></ng-content>',
                    host: { 'class': 'AptoTabNav' },
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".AptoTabNav-wrapper{margin-bottom:10px;border:none;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);border-radius:2px;background-color:#fff}.AptoTabNav{display:flex;flex-wrap:wrap;margin-bottom:-1px}.AptoTabNav-item{display:inline-block;flex:1 1 auto;line-height:1;text-align:center;text-decoration:none;color:#9e9e9e;font-size:1.2rem;padding:1.2rem 0;border-bottom:2px solid transparent;transition:color .15s ease-in-out,border-color .15s ease-in-out,font-weight .15s ease-in-out;outline:0}.AptoTabNav-item.AptoTabNav-item--active{border-bottom-color:#64b5f6;color:#64b5f6;font-weight:700}.AptoTabNav-item:hover{color:#64b5f6}"]
                }] }
    ];
    return AptoTabNavComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var nextId = 0;
var AptoTabChangeEvent = /** @class */ (function () {
    function AptoTabChangeEvent() {
    }
    return AptoTabChangeEvent;
}());
var AptoTabGroupComponent = /** @class */ (function () {
    function AptoTabGroupComponent(_changeDetectorRef) {
        this._changeDetectorRef = _changeDetectorRef;
        this._selectedIndex = null;
        this._indexToSelect = 0;
        this.selectedTabChange = new EventEmitter(true);
        this._groupId = nextId++;
    }
    Object.defineProperty(AptoTabGroupComponent.prototype, "selectedIndex", {
        get: /**
         * @return {?}
         */
        function () {
            return this._selectedIndex;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._indexToSelect = Number(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AptoTabGroupComponent.prototype, "groupId", {
        get: /**
         * @return {?}
         */
        function () {
            return this._groupId;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} e
     * @param {?} tab
     * @param {?} tabNum
     * @return {?}
     */
    AptoTabGroupComponent.prototype.handleClick = /**
     * @param {?} e
     * @param {?} tab
     * @param {?} tabNum
     * @return {?}
     */
    function (e, tab, tabNum) {
        e.preventDefault();
        this.selectedIndex = tabNum;
    };
    /**
     * @param {?} i
     * @return {?}
     */
    AptoTabGroupComponent.prototype.getAriaLabelledby = /**
     * @param {?} i
     * @return {?}
     */
    function (i) {
        return "AptoTabNav-" + this._groupId + "-" + i;
    };
    /**
     * @param {?} i
     * @return {?}
     */
    AptoTabGroupComponent.prototype.getTabPaneId = /**
     * @param {?} i
     * @return {?}
     */
    function (i) {
        return "AptoTabPane-" + this._groupId + "-" + i;
    };
    /**
     * @param {?} i
     * @return {?}
     */
    AptoTabGroupComponent.prototype.getTabNavId = /**
     * @param {?} i
     * @return {?}
     */
    function (i) {
        return "AptoTabNav-" + this._groupId + "-" + i;
    };
    /**
     * @param {?} i
     * @return {?}
     */
    AptoTabGroupComponent.prototype.getTabNavPaneId = /**
     * @param {?} i
     * @return {?}
     */
    function (i) {
        return "#AptoTabPane-" + this._groupId + "-" + i;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AptoTabGroupComponent.prototype.keyDownHandler = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var code = event.which || event.keyCode;
        switch (code) {
            case HOME:
                this._setFirstItemActive();
                event.preventDefault();
                break;
            case END:
                this._setLastItemActive();
                event.preventDefault();
                break;
            case RIGHT_ARROW:
                this._setNextItemActive();
                event.preventDefault();
                break;
            case LEFT_ARROW:
                this._setPreviousItemActive();
                event.preventDefault();
                break;
            default:
        }
    };
    /**
     * @param {?} index
     * @return {?}
     */
    AptoTabGroupComponent.prototype._createChangeEvent = /**
     * @param {?} index
     * @return {?}
     */
    function (index) {
        /** @type {?} */
        var event = new AptoTabChangeEvent;
        event.index = index;
        if (this.tabs && this.tabs.length) {
            event.tab = this.tabs.toArray()[index];
        }
        return event;
    };
    /**
     * @return {?}
     */
    AptoTabGroupComponent.prototype._setFirstItemActive = /**
     * @return {?}
     */
    function () {
        this.selectedIndex = 0;
    };
    /**
     * @return {?}
     */
    AptoTabGroupComponent.prototype._setNextItemActive = /**
     * @return {?}
     */
    function () {
        this.selectedIndex += 1;
        if (this.selectedIndex >= this.tabs.length - 1) {
            this._setFirstItemActive();
        }
    };
    /**
     * @return {?}
     */
    AptoTabGroupComponent.prototype._setPreviousItemActive = /**
     * @return {?}
     */
    function () {
        this.selectedIndex -= 1;
        if (this.selectedIndex <= 0) {
            this._setLastItemActive();
        }
    };
    /**
     * @return {?}
     */
    AptoTabGroupComponent.prototype._setLastItemActive = /**
     * @return {?}
     */
    function () {
        this.selectedIndex = this.tabs.length - 1;
    };
    /**
     * @return {?}
     */
    AptoTabGroupComponent.prototype.ngAfterContentChecked = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var _indexToSelect = this._indexToSelect =
            Math.min(this.tabs.length - 1, Math.max(this._indexToSelect || 0, 0));
        if (this._selectedIndex !== _indexToSelect && this._selectedIndex !== null) {
            this.selectedTabChange.emit(this._createChangeEvent(_indexToSelect));
        }
        this.tabs.forEach(function (tab, index) {
            tab.active = index === _indexToSelect;
        });
        if (this._selectedIndex !== _indexToSelect) {
            this._selectedIndex = _indexToSelect;
            this._changeDetectorRef.markForCheck();
        }
    };
    AptoTabGroupComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-tab-group',
                    template: "<div class=\"AptoTabNav-wrapper\">\n    <nav\n        aptoTabNav\n        role=\"tablist\"\n        (keydown)=\"keyDownHandler($event)\">\n        <a\n            *ngFor=\"let tab of tabs; let i = index\"\n            role=\"tab\"\n            tabindex=\"{{ selectedIndex == i ? 0 : -1 }}\"\n            class=\"AptoTabNav-item\"\n            [id]=\"getTabNavId(i)\"\n            [attr.href]=\"getTabNavPaneId(i)\"\n            [class.AptoTabNav-item--active]=\"selectedIndex == i\"\n            [attr.aria-selected]=\"selectedIndex == i ? 'true' : 'false'\"\n            [attr.aria-controls]=\"getTabPaneId(i)\"\n            [attr.aria-setsize]=\"tabs.length\"\n            [attr.aria-posinset]=\"i + 1\"\n            [attr.data-automation]=\"tab.automation\"\n            (click)=\"handleClick($event, tab, i)\">\n            <ng-template [ngIf]=\"tab.templateLabel\">\n                <ng-template [ngTemplateOutlet]=\"tab.templateLabel.templateRef\"></ng-template>\n            </ng-template>\n            <ng-template [ngIf]=\"!tab.templateLabel\">{{ tab.label }}</ng-template>\n        </a>\n    </nav>\n</div>\n<div class=\"AptoTabPane-wrapper\">\n    <div\n        aptoTabPane\n        *ngFor=\"let tab of tabs; let i = index\"\n        role=\"tabpanel\"\n        [id]=\"getTabPaneId(i)\"\n        [content]=\"tab.contentRef\"\n        [active]=\"tab.active\"\n        [class.AptoTabPane--active]=\"selectedIndex == i\"\n        [attr.aria-hidden]=\"selectedIndex == i ? false : true\"\n        [attr.aria-labelledby]=\"getAriaLabelledby(i)\"\n        [attr.data-automation]=\"tab.automation\">\n    </div>\n</div>\n",
                    host: { 'class': 'AptoTabGroup' },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".AptoTabGroup{font-family:\"Open Sans\",sans-serif;font-size:1.4rem;font-weight:500;line-height:1.5;margin:10px 0;padding:0;display:block}"]
                }] }
    ];
    /** @nocollapse */
    AptoTabGroupComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    AptoTabGroupComponent.propDecorators = {
        selectedIndex: [{ type: Input }],
        groupId: [{ type: Input }],
        selectedTabChange: [{ type: Output }],
        tabs: [{ type: ContentChildren, args: [AptoTabComponent,] }]
    };
    return AptoTabGroupComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoTabPaneComponent = /** @class */ (function () {
    function AptoTabPaneComponent() {
    }
    AptoTabPaneComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-tab-pane, [aptoTabPane]',
                    template: "<ng-template [ngIf]=\"active\">\n    <ng-template [ngTemplateOutlet]=\"content\"></ng-template>\n</ng-template>\n",
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: { 'class': 'AptoTabPane' },
                    styles: [".AptoTabPane{display:none;position:relative}.AptoTabPane.AptoTabPane--active{display:block}"]
                }] }
    ];
    AptoTabPaneComponent.propDecorators = {
        content: [{ type: Input }],
        position: [{ type: Input }],
        active: [{ type: Input }]
    };
    return AptoTabPaneComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoTabsComponentModule = /** @class */ (function () {
    function AptoTabsComponentModule() {
    }
    AptoTabsComponentModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        AptoTabGroupComponent,
                        AptoTabComponent,
                        AptoTabNavComponent,
                        AptoTabPaneComponent,
                        AptoTabContentDirective,
                        AptoTabLabelDirective
                    ],
                    exports: [
                        AptoTabGroupComponent,
                        AptoTabComponent,
                        AptoTabNavComponent,
                        AptoTabPaneComponent,
                        AptoTabContentDirective,
                        AptoTabLabelDirective
                    ]
                },] }
    ];
    return AptoTabsComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoTooltipContentDirective = /** @class */ (function () {
    function AptoTooltipContentDirective() {
    }
    AptoTooltipContentDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[apto-tooltip-content],apto-tooltip-content'
                },] }
    ];
    return AptoTooltipContentDirective;
}());
var AptoTooltipTriggerDirective = /** @class */ (function () {
    function AptoTooltipTriggerDirective() {
    }
    AptoTooltipTriggerDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[apto-tooltip-trigger],apto-tooltip-trigger'
                },] }
    ];
    return AptoTooltipTriggerDirective;
}());
/** @type {?} */
var nextAptoTooltipId = 0;
var AptoTooltipComponent = /** @class */ (function () {
    function AptoTooltipComponent(_doc) {
        this._doc = _doc;
        this.hoverDelay = 200;
        this.onItemHover = new EventEmitter();
        this.onItemLeave = new EventEmitter();
        this.visible = true;
        this.built = false;
        this._subscriptions = [];
        this.tipId = 'AptoTooltip--' + nextAptoTooltipId++;
    }
    /**
     * @return {?}
     */
    AptoTooltipComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var timeout;
        this._subscriptions.push(this.onItemHover.subscribe(function () {
            _this.visible = true;
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                _this.hoverHandler();
            }, _this.hoverDelay);
        }));
        this._subscriptions.push(this.onItemLeave.subscribe(function () {
            if (timeout) {
                clearTimeout(timeout);
            }
            _this.leaveHandler();
        }));
    };
    /**
     * @return {?}
     */
    AptoTooltipComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    /**
     * @return {?}
     */
    AptoTooltipComponent.prototype.buildElement = /**
     * @return {?}
     */
    function () {
        if (this.built) {
            return;
        }
        this.trigger.nativeElement.setAttribute('id', this.tipId);
        this.tip.nativeElement.setAttribute('aria-describedby', this.tipId);
        this._doc.body.appendChild(this.tip.nativeElement);
        this.built = true;
    };
    /**
     * @return {?}
     */
    AptoTooltipComponent.prototype.clickHandler = /**
     * @return {?}
     */
    function () {
        this.hoverHandler();
    };
    /**
     * @return {?}
     */
    AptoTooltipComponent.prototype.hoverHandler = /**
     * @return {?}
     */
    function () {
        if (!this.built) {
            this.buildElement();
        }
        if (!this.visible) {
            return;
        }
        this.tip.nativeElement.removeAttribute('hidden');
        /** @type {?} */
        var handleBounds = this.trigger.nativeElement.getBoundingClientRect();
        /** @type {?} */
        var tipBounds = this.tip.nativeElement.getBoundingClientRect();
        /** @type {?} */
        var x = (handleBounds.x + (handleBounds.width / 2)) - (tipBounds.width / 2);
        /** @type {?} */
        var y = handleBounds.y + handleBounds.height;
        /** @type {?} */
        var position = "translate3d(" + x + "px," + y + "px,0)";
        this.tip.nativeElement.style.transform = position;
    };
    /**
     * @return {?}
     */
    AptoTooltipComponent.prototype.leaveHandler = /**
     * @return {?}
     */
    function () {
        this.visible = false;
        if (this.built) {
            this.tip.nativeElement.setAttribute('hidden', 'hidden');
        }
    };
    AptoTooltipComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-tooltip',
                    template: "<div #tooltipTrigger\n     class=\"AptoTooltip-trigger\"\n     (mouseenter)=\"onItemHover.emit()\"\n     (mouseleave)=\"onItemLeave.emit()\"\n     (click)=\"clickHandler()\">\n    <ng-content select=\"apto-tooltip-trigger\"></ng-content>\n</div>\n<div #tooltipContent\n     hidden=\"hidden\"\n     class=\"AptoTooltip\"\n     role=\"tooltip\">\n    <div class=\"AptoTooltip-inner\">\n        <ng-content select=\"apto-tooltip-content\"></ng-content>\n    </div>\n</div>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".AptoTooltip-trigger{display:inline-block;cursor:pointer}.AptoTooltip{position:absolute;background:#fff;top:0;left:0;margin-top:4px;will-change:transform;max-width:350px;box-shadow:1px 1px 8px 2px rgba(0,0,0,.25)}.AptoTooltip[hidden]{display:none}.AptoTooltip .AptoTooltip-inner{font-family:\"Open Sans\",sans-serif;font-size:1.2rem;font-weight:500;color:#616161;padding:.5rem}"]
                }] }
    ];
    /** @nocollapse */
    AptoTooltipComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
    ]; };
    AptoTooltipComponent.propDecorators = {
        hoverDelay: [{ type: Input }],
        tip: [{ type: ViewChild, args: ['tooltipContent',] }],
        trigger: [{ type: ViewChild, args: ['tooltipTrigger',] }]
    };
    return AptoTooltipComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoTooltipComponentModule = /** @class */ (function () {
    function AptoTooltipComponentModule() {
    }
    AptoTooltipComponentModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        AptoTooltipComponent,
                        AptoTooltipTriggerDirective,
                        AptoTooltipContentDirective
                    ],
                    exports: [
                        AptoTooltipComponent,
                        AptoTooltipTriggerDirective,
                        AptoTooltipContentDirective
                    ]
                },] }
    ];
    return AptoTooltipComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoThumbnailComponent = /** @class */ (function () {
    function AptoThumbnailComponent() {
    }
    AptoThumbnailComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-thumbnail',
                    template: '<ng-content></ng-content>',
                    host: {
                        'class': 'AptoThumbnail'
                    },
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".AptoThumbnail{border:1px solid #bdbdbd;width:100px;height:80px;display:block;margin:8px;overflow:hidden}.AptoThumbnail img{display:inline-block;-o-object-fit:cover;object-fit:cover;width:100%;height:100%;max-height:100%;max-width:100%}"]
                }] }
    ];
    return AptoThumbnailComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoThumbnailComponentModule = /** @class */ (function () {
    function AptoThumbnailComponentModule() {
    }
    AptoThumbnailComponentModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        AptoThumbnailComponent
                    ],
                    exports: [
                        AptoThumbnailComponent
                    ]
                },] }
    ];
    return AptoThumbnailComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoHelpTextComponent = /** @class */ (function () {
    function AptoHelpTextComponent() {
        this.error = false;
        this._inline = false;
    }
    Object.defineProperty(AptoHelpTextComponent.prototype, "inline", {
        get: /**
         * @return {?}
         */
        function () {
            return this._inline;
        },
        set: /**
         * @param {?} inline
         * @return {?}
         */
        function (inline) {
            this._inline = coerceBooleanProperty(inline);
        },
        enumerable: true,
        configurable: true
    });
    AptoHelpTextComponent.decorators = [
        { type: Component, args: [{
                    template: '<ng-content></ng-content>',
                    selector: 'apto-help-text',
                    host: {
                        'class': 'AptoHelpText',
                        '[class.AptoHelpText--error]': 'error',
                        '[class.AptoHelpText--inline]': 'inline'
                    },
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".AptoHelpText{display:block;font-size:1rem;font-family:\"Open Sans\",sans-serif;font-weight:500;line-height:1.5;color:#bdbdbd}.AptoHelpText.AptoHelpText--error{color:#981818}.AptoHelpText.AptoHelpText--inline{display:inline-block}"]
                }] }
    ];
    AptoHelpTextComponent.propDecorators = {
        error: [{ type: Input }],
        inline: [{ type: Input }]
    };
    return AptoHelpTextComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoHelpTextComponentModule = /** @class */ (function () {
    function AptoHelpTextComponentModule() {
    }
    AptoHelpTextComponentModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        AptoHelpTextComponent
                    ],
                    exports: [
                        AptoHelpTextComponent
                    ]
                },] }
    ];
    return AptoHelpTextComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var APTO_CHECKBOX_REQUIRED_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return AptoCheckboxRequiredValidatorDirective; }),
    multi: true
};
var AptoCheckboxRequiredValidatorDirective = /** @class */ (function (_super) {
    __extends(AptoCheckboxRequiredValidatorDirective, _super);
    function AptoCheckboxRequiredValidatorDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AptoCheckboxRequiredValidatorDirective.decorators = [
        { type: Directive, args: [{
                    selector: "apto-checkbox[required][formControlName],\n                apto-checkbox[required][formControl], apto-checkbox[required][ngModel]",
                    providers: [
                        APTO_CHECKBOX_REQUIRED_VALIDATOR
                    ],
                    host: {
                        '[attr.required]': 'required ? "" : null'
                    }
                },] }
    ];
    return AptoCheckboxRequiredValidatorDirective;
}(CheckboxRequiredValidator));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var nextUniqueId = 0;
var AptoCheckboxChange = /** @class */ (function () {
    function AptoCheckboxChange() {
    }
    return AptoCheckboxChange;
}());
/** *
 * Provider Expression that allows apto-checkbox to register as a ControlValueAccessor.
 * This allows it to support [(ngModel)].
  @type {?} */
var APTO_CHECKBOX_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return AptoCheckboxComponent; }),
    multi: true
};
var AptoCheckboxBase = /** @class */ (function () {
    function AptoCheckboxBase() {
    }
    return AptoCheckboxBase;
}());
/** @type {?} */
var _AptoCheckboxMixinBase = mixinTabIndex(mixinDisabled(AptoCheckboxBase));
var AptoCheckboxComponent = /** @class */ (function (_super) {
    __extends(AptoCheckboxComponent, _super);
    function AptoCheckboxComponent(elementRef, _changeDetectorRef, tabIndex) {
        var _this = _super.call(this) || this;
        _this._changeDetectorRef = _changeDetectorRef;
        _this._uniqueId = "AptoCheckbox-" + ++nextUniqueId;
        _this._checked = false;
        _this._block = false;
        _this._disabled = false;
        _this._required = false;
        _this.name = null;
        _this.value = null;
        _this.id = _this._uniqueId;
        _this.ariaLabel = '';
        _this.ariaLabelledby = null;
        _this.change = new EventEmitter();
        _this._onTouched = function () { };
        _this._controlValueAccessorChangeFn = function () { };
        _this.tabIndex = parseInt(tabIndex, 10) || 0;
        return _this;
    }
    Object.defineProperty(AptoCheckboxComponent.prototype, "checked", {
        get: /**
         * @return {?}
         */
        function () { return this._checked; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value !== this.checked) {
                this._checked = coerceBooleanProperty(value);
                this._changeDetectorRef.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AptoCheckboxComponent.prototype, "block", {
        get: /**
         * @return {?}
         */
        function () { return this._block; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value !== this.block) {
                this._block = coerceBooleanProperty(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AptoCheckboxComponent.prototype, "disabled", {
        get: /**
         * @return {?}
         */
        function () { return this._disabled; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value !== this.disabled) {
                this._disabled = coerceBooleanProperty(value);
                this._changeDetectorRef.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AptoCheckboxComponent.prototype, "required", {
        get: /**
         * @return {?}
         */
        function () { return this._required; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._required = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AptoCheckboxComponent.prototype, "inputId", {
        get: /**
         * @return {?}
         */
        function () {
            return (this.id || this._uniqueId) + "-input";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AptoCheckboxComponent.prototype._getAriaChecked = /**
     * @return {?}
     */
    function () {
        return this.checked ? 'true' : 'false';
    };
    /**
     * @param {?} e
     * @return {?}
     */
    AptoCheckboxComponent.prototype._onInputChange = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        event.stopPropagation();
    };
    /**
     * @return {?}
     */
    AptoCheckboxComponent.prototype._onLabelTextChange = /**
     * @return {?}
     */
    function () {
        this._changeDetectorRef.markForCheck();
    };
    /**
     * @return {?}
     */
    AptoCheckboxComponent.prototype.focus = /**
     * @return {?}
     */
    function () {
        this._inputElement.nativeElement.focus();
    };
    /**
     * @return {?}
     */
    AptoCheckboxComponent.prototype.toggle = /**
     * @return {?}
     */
    function () {
        this.checked = !this.checked;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AptoCheckboxComponent.prototype.setValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.checked = !!value;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AptoCheckboxComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.checked = !!value;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    AptoCheckboxComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this._controlValueAccessorChangeFn = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    AptoCheckboxComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this._onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    AptoCheckboxComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.disabled = coerceBooleanProperty(isDisabled);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    AptoCheckboxComponent.prototype._onInputClick = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        event.stopPropagation();
        if (!this.disabled) {
            this.toggle();
            this._emitChangeEvent();
        }
    };
    /**
     * @return {?}
     */
    AptoCheckboxComponent.prototype._emitChangeEvent = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var event = new AptoCheckboxChange();
        event.source = this;
        event.checked = this.checked;
        this._controlValueAccessorChangeFn(this.checked);
        this.change.emit(event);
    };
    AptoCheckboxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-checkbox',
                    template: "<label\n    class=\"AptoCheckbox-label\"\n    [attr.for]=\"inputId\">\n    <div\n        class=\"AptoCheckbox-container\"\n        [class.AptoCheckbox-container--noSideMargin]=\"!checkboxLabel.textContent || !checkboxLabel.textContent.trim()\">\n        <input\n            #input\n            [id]=\"inputId\"\n            type=\"checkbox\"\n            [attr.name]=\"name\"\n            [attr.value]=\"value\"\n            [checked]=\"checked\"\n            [disabled]=\"disabled\"\n            [required]=\"required\"\n            [tabIndex]=\"tabIndex\"\n            [attr.aria-label]=\"ariaLabel || null\"\n            [attr.aria-labelledby]=\"ariaLabelledby\"\n            [attr.aria-checked]=\"_getAriaChecked()\"\n            (change)=\"_onInputChange($event)\"\n            (click)=\"_onInputClick($event)\">\n        <span class=\"AptoCheckbox-state\">\n            <svg version=\"1.1\"\n                focusable=\"false\"\n                class=\"AptoCheckbox-checkmark\"\n                viewBox=\"0 0 24 24\"\n                role=\"img\"\n                aria-hidden=\"true\"\n                xml:space=\"preserve\">\n                <path d=\"M0 0h24v24H0z\" fill=\"none\"/>\n                <path d=\"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z\"/>\n            </svg>\n        </span>\n    </div>\n    <span\n        #checkboxLabel\n        class=\"AptoCheckbox-labelContainer\"\n        (cdkObserveContent)=\"_onLabelTextChange()\">\n        <span style=\"display:none\">&nbsp;</span>\n        <ng-content></ng-content>\n    </span>\n</label>\n",
                    host: {
                        'class': 'AptoCheckbox',
                        '[attr.id]': 'id',
                        '[attr.tabindex]': 'null',
                        '[class.AptoCheckbox--checked]': 'checked',
                        '[class.AptoCheckbox--disabled]': 'disabled',
                        '[class.AptoCheckbox--block]': 'block'
                    },
                    providers: [APTO_CHECKBOX_CONTROL_VALUE_ACCESSOR],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".AptoCheckbox{display:inline-block;-webkit-tap-highlight-color:transparent;outline:0}.AptoCheckbox.AptoCheckbox--block{display:block}.AptoCheckbox.AptoCheckbox--disabled{opacity:.5}.AptoCheckbox.AptoCheckbox--disabled .AptoCheckbox-label{cursor:default}.AptoCheckbox-label{cursor:pointer;align-items:baseline;vertical-align:middle;display:inline-flex;white-space:nowrap}.AptoCheckbox-container{display:inline-block;height:14px;width:14px;line-height:0;margin:auto 8px auto auto;position:relative;flex-shrink:0}.AptoCheckbox-container.AptoCheckbox-container--noSideMargin{margin-right:0}.AptoCheckbox-container input{bottom:0;left:50%;border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;outline:0;-webkit-appearance:none}.AptoCheckbox-container .AptoCheckbox-state{top:0;left:0;right:0;bottom:0;position:absolute;box-sizing:border-box;background-color:#fff;border:1px solid #bdbdbd;transition:background-color .25s,border-color .25s}.AptoCheckbox-container .AptoCheckbox-state:hover{background-color:#eee}.AptoCheckbox-container .AptoCheckbox-state .AptoCheckbox-checkmark{opacity:0;top:0;left:0;right:0;bottom:0;position:absolute;width:100%;pointer-events:none;fill:#fff}.AptoCheckbox-container input:focus+.AptoCheckbox-state{background-color:#eee}.AptoCheckbox-container input:checked+.AptoCheckbox-state{background-color:#64b5f6;border-color:#64b5f6}.AptoCheckbox-container input:checked+.AptoCheckbox-state:hover{background-color:#64b5f6}.AptoCheckbox-container input:checked+.AptoCheckbox-state .AptoCheckbox-checkmark{opacity:1}.AptoCheckbox-labelContainer{line-height:14px}"]
                }] }
    ];
    /** @nocollapse */
    AptoCheckboxComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: ChangeDetectorRef },
        { type: String, decorators: [{ type: Attribute, args: ['tabindex',] }] }
    ]; };
    AptoCheckboxComponent.propDecorators = {
        tabIndex: [{ type: Input }],
        name: [{ type: Input }],
        value: [{ type: Input }],
        id: [{ type: Input }],
        ariaLabel: [{ type: Input, args: ['aria-label',] }],
        ariaLabelledby: [{ type: Input, args: ['aria-labelledby',] }],
        checked: [{ type: Input }],
        block: [{ type: Input }],
        disabled: [{ type: Input }],
        required: [{ type: Input }],
        _inputElement: [{ type: ViewChild, args: ['input',] }],
        change: [{ type: Output }]
    };
    return AptoCheckboxComponent;
}(_AptoCheckboxMixinBase));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoCheckboxComponentModule = /** @class */ (function () {
    function AptoCheckboxComponentModule() {
    }
    AptoCheckboxComponentModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        AptoCheckboxComponent,
                        AptoCheckboxRequiredValidatorDirective
                    ],
                    exports: [
                        AptoCheckboxComponent,
                        AptoCheckboxRequiredValidatorDirective
                    ]
                },] }
    ];
    return AptoCheckboxComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Class to coordinate unique selection based on name.
 * Intended to be consumed as an Angular service.
 * This service is needed because native radio change events are only fired on the item currently
 * being selected, and we still need to uncheck the previous selection.
 *
 * This service does not *store* any IDs and names because they may change at any time, so it is
 * less error-prone if they are simply passed through when the events occur.
 */
var UniqueSelectionDispatcher = /** @class */ (function () {
    function UniqueSelectionDispatcher() {
        this._listeners = [];
    }
    /**
     * Notify other items that selection for the given name has been set.
     * @param id ID of the item.
     * @param name Name of the item.
     */
    /**
     * Notify other items that selection for the given name has been set.
     * @param {?} id ID of the item.
     * @param {?} name Name of the item.
     * @return {?}
     */
    UniqueSelectionDispatcher.prototype.notify = /**
     * Notify other items that selection for the given name has been set.
     * @param {?} id ID of the item.
     * @param {?} name Name of the item.
     * @return {?}
     */
    function (id, name) {
        var e_1, _a;
        try {
            for (var _b = __values(this._listeners), _c = _b.next(); !_c.done; _c = _b.next()) {
                var listener = _c.value;
                listener(id, name);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
     * Listen for future changes to item selection.
     * @return Function used to deregister listener
     */
    /**
     * Listen for future changes to item selection.
     * @param {?} listener
     * @return {?} Function used to deregister listener
     */
    UniqueSelectionDispatcher.prototype.listen = /**
     * Listen for future changes to item selection.
     * @param {?} listener
     * @return {?} Function used to deregister listener
     */
    function (listener) {
        var _this = this;
        this._listeners.push(listener);
        return function () {
            _this._listeners = _this._listeners.filter(function (registered) {
                return listener !== registered;
            });
        };
    };
    /**
     * @return {?}
     */
    UniqueSelectionDispatcher.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._listeners = [];
    };
    UniqueSelectionDispatcher.decorators = [
        { type: Injectable }
    ];
    return UniqueSelectionDispatcher;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var nextUniqueId$1 = 0;
/** @type {?} */
var APTO_RADIO_GROUP_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return AptoRadioGroupDirective; }),
    multi: true
};
var AptoRadioChange = /** @class */ (function () {
    function AptoRadioChange(source, value) {
        this.source = source;
        this.value = value;
    }
    return AptoRadioChange;
}());
var AptoRadioGroupBase = /** @class */ (function () {
    function AptoRadioGroupBase() {
    }
    return AptoRadioGroupBase;
}());
/** @type {?} */
var _AptoRadioGroupMixinBase = mixinDisabled(AptoRadioGroupBase);
/**
 * A group of radio buttons. May contain one or more `<mat-radio-button>` elements.
 */
var AptoRadioGroupDirective = /** @class */ (function (_super) {
    __extends(AptoRadioGroupDirective, _super);
    function AptoRadioGroupDirective(_changeDetectorRef) {
        var _this = _super.call(this) || this;
        _this._changeDetectorRef = _changeDetectorRef;
        _this._value = null;
        _this._name = "AptoRadioGroup-" + nextUniqueId$1++;
        _this._selected = null;
        _this._isInitialized = false;
        _this._disabled = false;
        _this._required = false;
        _this.change = new EventEmitter();
        _this._controlValueAccessorChangeFn = function () { };
        _this.onTouched = function () { };
        return _this;
    }
    Object.defineProperty(AptoRadioGroupDirective.prototype, "name", {
        get: /**
         * @return {?}
         */
        function () { return this._name; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._name = value;
            this._updateRadioButtonNames();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AptoRadioGroupDirective.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () { return this._value; },
        set: /**
         * @param {?} newValue
         * @return {?}
         */
        function (newValue) {
            if (this._value !== newValue) {
                this._value = newValue;
                this._updateSelectedRadioFromValue();
                this._checkSelectedRadioButton();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AptoRadioGroupDirective.prototype, "selected", {
        get: /**
         * @return {?}
         */
        function () { return this._selected; },
        set: /**
         * @param {?} selected
         * @return {?}
         */
        function (selected) {
            this._selected = selected;
            this.value = selected ? selected.value : null;
            this._checkSelectedRadioButton();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AptoRadioGroupDirective.prototype, "disabled", {
        get: /**
         * @return {?}
         */
        function () { return this._disabled; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._disabled = coerceBooleanProperty(value);
            this._markRadiosForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AptoRadioGroupDirective.prototype, "required", {
        get: /**
         * @return {?}
         */
        function () { return this._required; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._required = coerceBooleanProperty(value);
            this._markRadiosForCheck();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AptoRadioGroupDirective.prototype._checkSelectedRadioButton = /**
     * @return {?}
     */
    function () {
        if (this._selected && !this._selected.checked) {
            this._selected.checked = true;
        }
    };
    /**
     * @return {?}
     */
    AptoRadioGroupDirective.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        this._isInitialized = true;
    };
    /**
     * @return {?}
     */
    AptoRadioGroupDirective.prototype._touch = /**
     * @return {?}
     */
    function () {
        if (this.onTouched) {
            this.onTouched();
        }
    };
    /**
     * @return {?}
     */
    AptoRadioGroupDirective.prototype._emitChangeEvent = /**
     * @return {?}
     */
    function () {
        if (this._isInitialized) {
            this.change.emit(new AptoRadioChange(/** @type {?} */ ((this._selected)), this._value));
        }
    };
    /**
     * @return {?}
     */
    AptoRadioGroupDirective.prototype._markRadiosForCheck = /**
     * @return {?}
     */
    function () {
        if (this._radios) {
            this._radios.forEach(function (radio) { return radio._markForCheck(); });
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AptoRadioGroupDirective.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
        this._changeDetectorRef.markForCheck();
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    AptoRadioGroupDirective.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this._controlValueAccessorChangeFn = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    AptoRadioGroupDirective.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    AptoRadioGroupDirective.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.disabled = isDisabled;
        this._changeDetectorRef.markForCheck();
    };
    /**
     * @return {?}
     */
    AptoRadioGroupDirective.prototype._updateRadioButtonNames = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this._radios) {
            this._radios.forEach(function (radio) {
                radio.name = _this.name;
            });
        }
    };
    /**
     * @return {?}
     */
    AptoRadioGroupDirective.prototype._updateSelectedRadioFromValue = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var isAlreadySelected = this._selected !== null && this._selected.value === this._value;
        if (this._radios && !isAlreadySelected) {
            this._selected = null;
            this._radios.forEach(function (radio) {
                radio.checked = _this.value === radio.value;
                if (radio.checked) {
                    _this._selected = radio;
                }
            });
        }
    };
    AptoRadioGroupDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[apto-radio-group],apto-radio-group',
                    providers: [APTO_RADIO_GROUP_CONTROL_VALUE_ACCESSOR],
                    host: {
                        'role': 'radiogroup',
                        'class': 'AptoRadioGroup',
                    }
                },] }
    ];
    /** @nocollapse */
    AptoRadioGroupDirective.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    AptoRadioGroupDirective.propDecorators = {
        name: [{ type: Input }],
        value: [{ type: Input }],
        selected: [{ type: Input }],
        disabled: [{ type: Input, args: ['disabled',] }],
        required: [{ type: Input }],
        change: [{ type: Output }],
        _radios: [{ type: ContentChildren, args: [forwardRef(function () { return AptoRadioButtonComponent; }),
                    { descendants: true },] }]
    };
    return AptoRadioGroupDirective;
}(_AptoRadioGroupMixinBase));
var AptoRadioButtonBase = /** @class */ (function () {
    function AptoRadioButtonBase() {
    }
    return AptoRadioButtonBase;
}());
/** @type {?} */
var _AptoRadioButtonMixinBase = mixinTabIndex(AptoRadioButtonBase);
var AptoRadioButtonComponent = /** @class */ (function (_super) {
    __extends(AptoRadioButtonComponent, _super);
    function AptoRadioButtonComponent(radioGroup, _changeDetectorRef, _radioDispatcher) {
        var _this = _super.call(this) || this;
        _this._changeDetectorRef = _changeDetectorRef;
        _this._radioDispatcher = _radioDispatcher;
        _this._uniqueId = "AptoRadioButton-" + ++nextUniqueId$1;
        _this._checked = false;
        _this._disabled = false;
        _this._required = false;
        _this._value = null;
        _this._block = false;
        _this.id = _this._uniqueId;
        _this.change = new EventEmitter();
        _this._removeUniqueSelectionListener = function () { };
        _this.radioGroup = radioGroup;
        _this._removeUniqueSelectionListener =
            _radioDispatcher.listen(function (id, name) {
                if (id !== _this.id && name === _this.name) {
                    _this.checked = false;
                }
            });
        return _this;
    }
    Object.defineProperty(AptoRadioButtonComponent.prototype, "checked", {
        get: /**
         * @return {?}
         */
        function () { return this._checked; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            /** @type {?} */
            var newCheckedState = coerceBooleanProperty(value);
            if (this._checked !== newCheckedState) {
                this._checked = newCheckedState;
                if (newCheckedState && this.radioGroup && this.radioGroup.value !== this.value) {
                    this.radioGroup.selected = this;
                }
                else if (!newCheckedState && this.radioGroup && this.radioGroup.value === this.value) {
                    this.radioGroup.selected = null;
                }
                if (newCheckedState) {
                    this._radioDispatcher.notify(this.id, this.name);
                }
                this._changeDetectorRef.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AptoRadioButtonComponent.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () { return this._value; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (this._value !== value) {
                this._value = value;
                if (this.radioGroup !== null) {
                    if (!this.checked) {
                        this.checked = this.radioGroup.value === value;
                    }
                    if (this.checked) {
                        this.radioGroup.selected = this;
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AptoRadioButtonComponent.prototype, "disabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this._disabled || (this.radioGroup !== null && this.radioGroup.disabled);
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            /** @type {?} */
            var newDisabledState = coerceBooleanProperty(value);
            if (this._disabled !== newDisabledState) {
                this._disabled = newDisabledState;
                this._changeDetectorRef.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AptoRadioButtonComponent.prototype, "block", {
        get: /**
         * @return {?}
         */
        function () { return this._block; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._block = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AptoRadioButtonComponent.prototype, "required", {
        get: /**
         * @return {?}
         */
        function () {
            return this._required || (this.radioGroup && this.radioGroup.required);
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._required = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AptoRadioButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.radioGroup) {
            this.checked = this.radioGroup.value === this._value;
            this.name = this.radioGroup.name;
        }
    };
    /**
     * @return {?}
     */
    AptoRadioButtonComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._removeUniqueSelectionListener();
    };
    Object.defineProperty(AptoRadioButtonComponent.prototype, "inputId", {
        get: /**
         * @return {?}
         */
        function () {
            return (this.id || this._uniqueId) + "-input";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AptoRadioButtonComponent.prototype.focus = /**
     * @return {?}
     */
    function () {
        this._inputElement.nativeElement.focus();
    };
    /**
     * @return {?}
     */
    AptoRadioButtonComponent.prototype._markForCheck = /**
     * @return {?}
     */
    function () {
        this._changeDetectorRef.markForCheck();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AptoRadioButtonComponent.prototype._onInputClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.stopPropagation();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AptoRadioButtonComponent.prototype._onInputChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.stopPropagation();
        /** @type {?} */
        var groupValueChanged = this.radioGroup && this.value !== this.radioGroup.value;
        this.checked = true;
        this._emitChangeEvent();
        if (this.radioGroup) {
            this.radioGroup._controlValueAccessorChangeFn(this.value);
            this.radioGroup._touch();
            if (groupValueChanged) {
                this.radioGroup._emitChangeEvent();
            }
        }
    };
    /**
     * @return {?}
     */
    AptoRadioButtonComponent.prototype._emitChangeEvent = /**
     * @return {?}
     */
    function () {
        this.change.emit(new AptoRadioChange(this, this._value));
    };
    AptoRadioButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apto-radio-button',
                    template: "<label\n    #label\n    class=\"AptoRadioButton-label\"\n    [attr.for]=\"inputId\">\n    <div\n        class=\"AptoRadioButton-container\"\n        [class.AptoRadioButton-container--noSideMargin]=\"!radioLabel.textContent || !radioLabel.textContent.trim()\">\n        <input\n            #input\n            [id]=\"inputId\"\n            type=\"radio\"\n            [attr.name]=\"name\"\n            [attr.value]=\"value\"\n            [checked]=\"checked\"\n            [disabled]=\"disabled\"\n            [required]=\"required\"\n            [tabIndex]=\"tabIndex\"\n            [attr.aria-label]=\"ariaLabel || null\"\n            [attr.aria-labelledby]=\"ariaLabelledby\"\n            [attr.aria-describedby]=\"ariaDescribedby\"\n            (change)=\"_onInputChange($event)\"\n            (click)=\"_onInputClick($event)\">\n        <span class=\"AptoRadioButton-state\"></span>\n    </div>\n    <span\n        #radioLabel\n        class=\"AptoRadioButton-labelContainer\">\n        <span style=\"display:none\">&nbsp;</span>\n        <ng-content></ng-content>\n    </span>\n</label>\n",
                    host: {
                        'class': 'AptoRadioButton',
                        '[class.AptoRadioButton--checked]': 'checked',
                        '[class.AptoRadioButton--disabled]': 'disabled',
                        '[class.AptoRadioButton--block]': 'block',
                        '[attr.id]': 'id',
                        '[attr.tabindex]': 'null',
                        '(focus)': '_inputElement.nativeElement.focus()'
                    },
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".AptoRadioButton{display:inline-block;-webkit-tap-highlight-color:transparent;outline:0}.AptoRadioButton.AptoRadioButton--block{display:block}.AptoRadioButton.AptoRadioButton--disabled{opacity:.5}.AptoRadioButton.AptoRadioButton--disabled .AptoRadioButton-label{cursor:default}.AptoRadioButton-label{cursor:pointer;align-items:baseline;vertical-align:middle;display:inline-flex;white-space:nowrap}.AptoRadioButton-container{display:inline-block;height:14px;width:14px;line-height:0;margin:auto 8px auto auto;position:relative;flex-shrink:0}.AptoRadioButton-container.AptoRadioButton-container--noSideMargin{margin-right:0}.AptoRadioButton-container input{bottom:0;left:50%;border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;outline:0;-webkit-appearance:none}.AptoRadioButton-container .AptoRadioButton-state{display:block;top:0;left:0;right:0;bottom:0;position:absolute;border-radius:50%;background-color:transparent;border:1px solid #bdbdbd;transition:background-color .25s,border-color .25s}.AptoRadioButton-container .AptoRadioButton-state:after{content:\"\";background-color:transparent;top:0;left:0;right:0;bottom:0;position:absolute;margin:2px;border-radius:50%;transition:background-color .25s}.AptoRadioButton-container .AptoRadioButton-state:hover,.AptoRadioButton-container input:focus+.AptoRadioButton-state{background-color:#eee}.AptoRadioButton-container input:checked+.AptoRadioButton-state{border-color:#64b5f6;background-color:transparent}.AptoRadioButton-container input:checked+.AptoRadioButton-state:after{background-color:#64b5f6}.AptoRadioButton-container input:checked+.AptoRadioButton-state:hover{background-color:transparent}.AptoRadioButton-labelContainer{line-height:14px}"]
                }] }
    ];
    /** @nocollapse */
    AptoRadioButtonComponent.ctorParameters = function () { return [
        { type: AptoRadioGroupDirective, decorators: [{ type: Optional }] },
        { type: ChangeDetectorRef },
        { type: UniqueSelectionDispatcher }
    ]; };
    AptoRadioButtonComponent.propDecorators = {
        tabIndex: [{ type: Input }],
        id: [{ type: Input }],
        name: [{ type: Input }],
        ariaLabel: [{ type: Input, args: ['aria-label',] }],
        ariaLabelledby: [{ type: Input, args: ['aria-labelledby',] }],
        ariaDescribedby: [{ type: Input, args: ['aria-describedby',] }],
        checked: [{ type: Input }],
        value: [{ type: Input }],
        disabled: [{ type: Input }],
        block: [{ type: Input }],
        required: [{ type: Input }],
        change: [{ type: Output }],
        _inputElement: [{ type: ViewChild, args: ['input',] }]
    };
    return AptoRadioButtonComponent;
}(_AptoRadioButtonMixinBase));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoRadioButtonComponentModule = /** @class */ (function () {
    function AptoRadioButtonComponentModule() {
    }
    AptoRadioButtonComponentModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        AptoRadioGroupDirective,
                        AptoRadioButtonComponent
                    ],
                    exports: [
                        AptoRadioGroupDirective,
                        AptoRadioButtonComponent
                    ],
                    providers: [
                        UniqueSelectionDispatcher
                    ]
                },] }
    ];
    return AptoRadioButtonComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { mixinDisabled, mixinTabIndex, ButtonKinds, ButtonTypes, AptoHoldButtonDirective, AptoButtonComponent, AptoButtonComponentModule, AptoCardComponentModule, AptoCardComponent, AptoCardContentComponent, AptoCardFooterLeftDirective, AptoCardFooterRightDirective, AptoCardFooterComponent, AptoCardHeaderComponent, AptoGridColumnDirective, AptoGridRowComponent, AptoGridContainerComponent, AptoGridComponentModule, AptoHeaderComponent, AptoHeaderComponentModule, IconColors, IconStatus, AptoIconComponent, AptoIconComponentModule, getAptoIconNameNotFoundError, getAptoIconNoHttpProviderError, getAptoIconFailedToSanitizeUrlError, getAptoIconFailedToSanitizeLiteralError, ICON_REGISTRY_PROVIDER_FACTORY, AptoIconRegistry, ICON_REGISTRY_PROVIDER, AptoListItemIconDirective, AptoListItemComponent, AptoListComponent, AptoListComponentModule, AptoLoaderComponent, AptoLoaderComponentModule, AptoParagraphComponent, AptoParagraphComponentModule, AptoShimmerComponent, AptoShimmerComponentModule, AptoTabContentDirective, AptoTabLabelDirective, AptoTabComponent, AptoTabNavComponent, AptoTabChangeEvent, AptoTabGroupComponent, AptoTabPaneComponent, AptoTabsComponentModule, AptoTooltipContentDirective, AptoTooltipTriggerDirective, AptoTooltipComponent, AptoTooltipComponentModule, TAB, ENTER, ESCAPE, SPACE, END, HOME, LEFT_ARROW, UP_ARROW, RIGHT_ARROW, DOWN_ARROW, coerceBooleanProperty, dispatchEvent, dispatchFakeEvent, createFakeEvent, sortedClassNames, AptoThumbnailComponent, AptoThumbnailComponentModule, AptoHelpTextComponent, AptoHelpTextComponentModule, APTO_CHECKBOX_REQUIRED_VALIDATOR, AptoCheckboxRequiredValidatorDirective, AptoCheckboxChange, APTO_CHECKBOX_CONTROL_VALUE_ACCESSOR, AptoCheckboxBase, _AptoCheckboxMixinBase, AptoCheckboxComponent, AptoCheckboxComponentModule, APTO_RADIO_GROUP_CONTROL_VALUE_ACCESSOR, AptoRadioChange, AptoRadioGroupBase, _AptoRadioGroupMixinBase, AptoRadioGroupDirective, AptoRadioButtonBase, _AptoRadioButtonMixinBase, AptoRadioButtonComponent, AptoRadioButtonComponentModule, UniqueSelectionDispatcher };

//# sourceMappingURL=apto-ui.js.map